export const ONLINE_PROBLEM_SPECS = [
  {
    "title": "01 Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "1-bit and 2-bit Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "132 Pattern",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "2 Keys Keyboard",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "24 Game",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "3 Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "3 Sum Closest",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "threeSumClosest",
    "source": "online"
  },
  {
    "title": "3Sum Smaller",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "3Sum With Multiplicity",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "4 Keys Keyboard",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "4 Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "4Sum II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "A Number After a Double Reversal",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Abbreviating the Product of a Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Absolute Difference Between Maximum and Minimum K Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Accepted Candidates From the Interviews",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Account Balance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Account Balance After Rounded Purchase",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Accounts Merge",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Active Businesses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Active Users",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Activity Participants",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Actors and Directors Who Cooperated At Least Three Times",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Ad-Free Sessions",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Add and Search Word - Data structure design",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Add Binary",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Add Bold Tag in String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Add Digits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Add Edges to Make Degrees of All Nodes Even",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Add Minimum Number of Rungs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Add One Row to Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Add Strings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Add to Array-Form of Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Add Two Integers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Add Two Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Add Two Numbers II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Add Two Polynomials Represented as Linked Lists",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Add Two Promises",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Addictive Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Adding Spaces to a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Adding Two Negabinary Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Adjacent Increasing Subarrays Detection I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Adjacent Increasing Subarrays Detection II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Ads Performance",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Advantage Shuffle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Airplane Seat Assignment Probability",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Alert Using Same Key-Card Three or More Times in a One Hour Period",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Alice and Bob Playing Flower Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Alien Dictionary",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "All Ancestors of a Node in a Directed Acyclic Graph",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "All Divisions With the Highest Score of a Binary Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "All Elements in Two Binary Search Trees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "All Nodes Distance K in Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "All O\\`one Data Structure",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "All Paths from Source Lead to Destination",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "All Paths From Source to Target",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "All People Report to the Given Manager",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "All Possible Full Binary Trees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "All the Matches of the League",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "All the Pairs With the Maximum Number of Common Followers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "All Valid Triplets That Can Represent a Country",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Allocate Mailboxes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Allow One Function Call",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Alphabet Board Path",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Alt and Tab Simulation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Alternating Digit Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Alternating Groups I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Alternating Groups II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Alternating Groups III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Ambiguous Coordinates",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Amount of New Area Painted Each Day",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Amount of Time for Binary Tree to Be Infected",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Analyze Organization Hierarchy",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Analyze Subscription Conversion",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Analyze User Website Visit Pattern",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Android Unlock Patterns",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Angle Between Hands of a Clock",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Angles of a Triangle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Ant on the Boundary",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Append Characters to String to Make Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Append K Integers With Minimal Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Apple Redistribution into Boxes",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Apples & Oranges",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Apply Bitwise Operations to Make Strings Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Apply Discount Every n Orders",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Apply Discount to Prices",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Apply Operations on Array to Maximize Sum of Squares",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Apply Operations to an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Apply Operations to Make All Array Elements Equal to Zero",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Apply Operations to Make String Empty",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Apply Operations to Make Two Strings Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Apply Operations to Maximize Frequency Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Apply Operations to Maximize Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Apply Substitutions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Apply Transform Over Each Element in Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Arithmetic Slices",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Arithmetic Slices II - Subsequence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Arithmetic Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Armstrong Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Arrange Table by Gender",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Arranging Coins",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Array Nesting",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Array of Doubled Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Array of Objects to Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Array Partition I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Array Prototype ForEach",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Array Prototype Last",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Array Reduce Transformation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Array Transformation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Array Upper Bound",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Array With Elements Not Equal to Average of Neighbors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Array Wrapper",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Article Views I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Article Views II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "As Far from Land as Possible",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Assign Cookies",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Assign Elements to Groups with Constraints",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Asteroid Collision",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Available Captures for Rook",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Average Height of Buildings in Each Segment",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Average of Levels in Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Average Salary Excluding the Minimum and Maximum Salary",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Average Salary: Departments VS Company",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Average Selling Price",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Average Time of Process per Machine",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Average Value of Even Numbers That Are Divisible by Three",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Average Waiting Time",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Avoid Flood in The City",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Backspace String Compare",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Bag of Tokens",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Balance a Binary Search Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Balanced Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Balanced K-Factor Decomposition",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bank Account Summary",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bank Account Summary II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Base 7",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Baseball Game",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Basic Calculator",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Basic Calculator II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Basic Calculator III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Basic Calculator IV",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Battleships in a Board",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Beautiful Arrangement",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Beautiful Arrangement II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Beautiful Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Beautiful Pairs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Beautiful Towers I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Beautiful Towers II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Before and After Puzzle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Best Meeting Point",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Best Poker Hand",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Best Position for a Service Centre",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Geometry"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Best Reachable Tower",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Best Sightseeing Pair",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Best Team With No Conflicts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Best Time to Buy and Sell Stock",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Best Time to Buy and Sell Stock II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Best Time to Buy and Sell Stock III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Best Time to Buy and Sell Stock IV",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Best Time to Buy and Sell Stock using Strategy",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Best Time to Buy and Sell Stock V",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Best Time to Buy and Sell Stock with Cooldown",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Best Time to Buy and Sell Stock with Transaction Fee",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Better Compression of String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Big Countries",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Biggest Single Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Biggest Window Between Visits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bikes Last Time Used",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Gap",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Number with Alternating Bits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Prefix Divisible By 5",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Search",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Binary Search Tree Iterator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Search Tree Iterator II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Search Tree to Greater Sum Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Binary Searchable Numbers in an Unsorted Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary String With Substrings Representing 1 To N",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Subarrays With Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Binary Tree Cameras",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Coloring Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Binary Tree Inorder Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Binary Tree Level Order Traversal",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Level Order Traversal II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Longest Consecutive Sequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Longest Consecutive Sequence II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Maximum Path Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Nodes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Paths",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Postorder Traversal",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Binary Tree Preorder Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Binary Tree Pruning",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Binary Tree Right Side View",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Tilt",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Binary Tree Upside Down",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Vertical Order Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Tree Zigzag Level Order Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Binary Trees With Factors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Binary Watch",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bind Function to Context",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bitwise AND of Numbers Range",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bitwise OR of Adjacent Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bitwise OR of All Subsequence Sums",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bitwise OR of Even Numbers in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bitwise ORs of Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bitwise User Permissions Analysis",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bitwise XOR of All Pairings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Block Placement Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Boats to Save People",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bomb Enemy",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Booking Concert Tickets in Groups",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Books with NULL Ratings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Boundary of Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Brace Expansion",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Brace Expansion II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Break a Palindrome",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Brick Wall",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bricks Falling When Hit",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Brightest Position on Street",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Broken Calculator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Buddy Strings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Build a Matrix With Conditions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Build an Array With Stack Operations",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Build Array from Permutation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Build Array Where You Can Find The Maximum Exactly K Comparisons",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Build Binary Expression Tree From Infix Expression",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Build the Equation",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Building Boxes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Building H2O",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Concurrency"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Buildings With an Ocean View",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bulb Switcher",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bulb Switcher II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bulb Switcher III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bulb Switcher IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Bulls and Cows",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Burst Balloons",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Bus Routes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Button with Longest Push Time",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Buy Two Chocolates",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Cache With Time Limit",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Amount Paid in Taxes",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Compressed Mean",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Delayed Arrival Time",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Digit Sum of a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Money in Leetcode Bank",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Calculate Orders Within Each Interval",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Parking Fees and Duration",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Product Final Price",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Salaries",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Score After Performing Instructions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Special Bonus",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate the Influence of Each Salesperson",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculate Trapping Rain Water",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Calculator with Method Chaining",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Call Function with Custom Context",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Camelcase Matching",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Campus Bikes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Campus Bikes II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Can Convert String in K Moves",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Can I Win",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Can Make Arithmetic Progression From Sequence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Can Make Palindrome from Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Can Place Flowers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Can You Eat Your Favorite Candy on Your Favorite Day?",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Candy",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Candy Crush",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Capacity To Ship Packages Within D Days",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Capital Gain/Loss",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Capitalize the Title",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Car Fleet",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Car Fleet II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Car Pooling",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Card Flipping Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Cat and Mouse",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Cat and Mouse II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Categorize Box According to Criteria",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Cells in a Range on an Excel Sheet",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Cells with Odd Values in a Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "CEO Subordinate Hierarchy",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Chalkboard XOR Game",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Champagne Tower",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Change Data Type",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Change Minimum Characters to Satisfy One of Three Conditions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Change Null Values in a Table to the Previous Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Change the Root of a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Cheapest Flights Within K Stops",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check Adjacent Digit Differences",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check Array Formation Through Concatenation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check Balanced String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check Completeness of a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Check Digitorial Permutation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check Distances Between Same Letters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check Divisibility by Digit Sum and Product",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check for Contradictions in Equations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Check Good Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If a Number Is Majority Element in a Sorted Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if a Parentheses String Can Be Valid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If a String Can Break Another String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If a String Contains All Binary Codes of Size K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If a String Is a Valid Sequence from Root to Leaves Path in a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Check if a String Is an Acronym of Words",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If a Word Occurs As a Prefix of Any Word in a Sentence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If All 1's Are at Least Length K Places Away",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if All A's Appears Before All B's",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if All Characters Have Equal Number of Occurrences",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if All the Integers in a Range Are Covered",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if an Array Is Consecutive",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if an Original String Exists Given Two Encoded Strings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Check if Any Element Has Prime Frequency",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Array is Good",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Array Is Sorted and Rotated",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If Array Pairs Are Divisible by k",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Binary String Has at Most One Segment of Ones",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Bitwise OR Has Trailing Zeros",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if DFS Strings Are Palindromes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If Digits Are Equal in String After Operations I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If Digits Are Equal in String After Operations II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Every Row and Column Contains All Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Grid can be Cut into Sections",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Check if Grid Satisfies Conditions",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If It Is a Good Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If It Is a Straight Line",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if it is Possible to Split Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Matrix Is X-Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Move is Legal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If N and Its Double Exist",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Number Has Equal Digit Count and Digit Value",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Number is a Sum of Powers of Three",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Numbers Are Ascending in a Sentence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Object Instance of Class",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if One String Swap Can Make Strings Equal",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Point Is Reachable",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If String Is a Prefix of Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if String Is Decomposable Into Value-Equal Substrings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If String Is Transformable With Substring Sort Operations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Strings Can be Made Equal With Operations I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Strings Can be Made Equal With Operations II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if The Number is Fascinating",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if the Rectangle Corner Is Reachable",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Check if the Sentence Is Pangram",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if There is a Path With Equal Number of 0's And 1's",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Check if There Is a Valid Parentheses String Path",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Check if There is a Valid Partition For The Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Check if There is a Valid Path in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Two Chessboard Squares Have the Same Color",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If Two Expression Trees are Equivalent",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Check If Two String Arrays are Equivalent",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Word Can Be Placed In Crossword",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check if Word Equals Summation of Two Words",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check If Word Is Valid After Substitutions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Check Knight Tour Configuration",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Check Whether Two Strings are Almost Equivalent",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Checking Existence of Edge Length Limited Paths",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Checking Existence of Edge Length Limited Paths II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Cherry Pickup",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Cherry Pickup II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Choose Edges to Maximize Score in a Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Choose K Elements With Maximum Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Choose Numbers From Two Arrays in Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Chunk Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Cinema Seat Allocation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Circle and Rectangle Overlapping",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Circular Array Loop",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Circular Permutation in Binary Representation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Circular Sentence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Class Performance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Classes More Than 5 Students",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Classifying Triangles by Lengths",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Clear Digits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Climbing Stairs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Climbing Stairs II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Clone Binary Tree With Random Pointer",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Clone Graph",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Clone N-ary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Closest Binary Search Tree Value",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Closest Binary Search Tree Value II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Closest Dessert Cost",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Closest Divisors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Closest Equal Element Queries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Closest Fair Integer",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Closest Leaf in a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Closest Node to Path in Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Closest Nodes Queries in a Binary Search Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Closest Prime Numbers in Range",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Closest Room",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Closest Subsequence Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Clumsy Factorial",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Coin Change",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Coin Change 2",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Coin Path",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Collect Coins in a Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Collecting Chocolates",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Color the Triangle Red",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Coloring A Border",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Combination Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Combination Sum II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Combination Sum III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Combination Sum IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Combinations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Combine Two Tables",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Compact Object",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Compare Strings by Frequency of the Smallest Character",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Compare Sums of Bitonic Parts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Compare Version Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Complement of Base 10 Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Complete Binary Tree Inserter",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Complete Prime Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Complex Number Multiplication",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Compute Alternating Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Compute Decimal Representation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Compute the Rank as a Percentage",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Concatenate Array With Reverse",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Concatenate Non-Zero Digits and Multiply by Sum I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Concatenate Non-Zero Digits and Multiply by Sum II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Concatenate the Name and the Profession",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Concatenated Divisibility",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Concatenated Words",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Concatenation of Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Concatenation of Consecutive Binary Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Confirmation Rate",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Confusing Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Confusing Number II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Connecting Cities With Minimum Cost",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Consecutive Available Seats",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Consecutive Available Seats II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Consecutive Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Consecutive Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Consecutive Numbers Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Consecutive Transactions with Increasing Amounts",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Constrained Subset Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Construct 2D Grid Matching Graph Layout",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct Binary Search Tree from Preorder Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Construct Binary Tree from Inorder and Postorder Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct Binary Tree from Preorder and Inorder Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct Binary Tree from Preorder and Postorder Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Construct Binary Tree from String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Construct K Palindrome Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct Product Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct Quad Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Construct Smallest Number From DI String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct String from Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Construct String with Minimum Cost",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Construct String with Minimum Cost (Easy)",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Construct String With Repeat Limit",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct Target Array With Multiple Sums",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct the Lexicographically Largest Valid Sequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct the Longest New String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct the Minimum Bitwise Array I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct the Minimum Bitwise Array II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct the Rectangle",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct Uniform Parity Array I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Construct Uniform Parity Array II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Constructing Two Increasing Arrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Contain Virus",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Container With Most Water",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Contains Duplicate",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Contains Duplicate II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Contains Duplicate III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Contiguous Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Continuous Subarray Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Continuous Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Convert 1D Array Into 2D Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert a Number to Hexadecimal",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert an Array Into a 2D Array With Conditions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert Binary Number in a Linked List to Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Convert Binary Search Tree to Sorted Doubly Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Convert BST to Greater Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Convert Callback Based Function to Promise Based Function",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert Date Format",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert Date to Binary",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert Doubly Linked List to Array I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Convert Doubly Linked List to Array II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Convert Integer to the Sum of Two No-Zero Integers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert JSON String to Object",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert Number Words to Digits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert Object to JSON String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert Sorted Array to Binary Search Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert Sorted List to Binary Search Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert the Temperature",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convert to Base -2",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Convex Polygon",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Coordinate With Maximum Network Quality",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Copy List with Random Pointer",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Corporate Flight Bookings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Correct a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count All Possible Routes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count All Valid Pickup and Delivery Options",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Almost Equal Pairs I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Count Almost Equal Pairs II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Count Alternating Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Anagrams",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count and Say",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Apples and Oranges",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Array Pairs Divisible by K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Artifacts That Can Be Extracted",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Artist Occurrences On Spotify Ranking List",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Asterisks",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Beautiful Numbers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Beautiful Splits in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Beautiful Substrings I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Beautiful Substrings II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Binary Palindromic Numbers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Binary Substrings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Bowl Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Count Caesar Cipher Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Cells in Overlapping Horizontal and Vertical Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Collisions of Monkeys on a Polygon",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Collisions on a Road",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Commas in Range",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Commas in Range II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Common Words With One Occurrence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Complete Subarrays in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Complete Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Complete Tree Nodes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Count Connected Components in LCM Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Count Connected Subgraphs with Even Node Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Count Covered Buildings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Days Spent Together",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Days Without Meetings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Count Different Palindromic Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Digit Appearances",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Distinct Integers After Removing Zeros",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Distinct Numbers on Board",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Distinct Subarrays Divisible by K in Sorted Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Distinct Ways to Form Target from Two Strings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Dominant Indices",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Elements With at Least K Greater Values",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Count Elements With Maximum Frequency",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Elements With Strictly Smaller and Greater Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Equal and Divisible Pairs in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Fancy Numbers in a Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Fertile Pyramids in a Land",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Good Integers in a Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Good Integers on a Grid Path",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Good Meals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Good Nodes in Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Count Good Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Good Subarrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Count Good Triplets",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Good Triplets in an Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Count Hills and Valleys in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Houses in a Circular Street",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Houses in a Circular Street II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Increasing Quadruplets",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Indices With Opposite Parity",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Integers in Intervals",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Integers With Even Digit Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Islands With Total Value Divisible by K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Items Matching a Rule",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count K-Reducible Numbers Less Than N",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count K-Subsequences of a String With Maximum Beauty",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count K-th Roots in a Range",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Count Largest Group",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Lattice Points Inside a Circle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Mentions Per User",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Monobit Integers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Negative Numbers in a Sorted Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Nice Pairs in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count No-Zero Pairs That Sum to N",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Nodes Equal to Average of Subtree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Nodes Equal to Sum of Descendants",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Nodes That Are Great Enough",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Count Nodes With the Highest Score",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Non Adjacent Subsets in a Rooted Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Non Decreasing Arrays With Given Digit Sums",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Non-Decreasing Subarrays After K Operations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Number of Bad Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Number of Balanced Permutations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Number of Distinct Integers After Reverse Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Number of Homogenous Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Number of Maximum Bitwise-OR Subsets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Number of Nice Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Number of Pairs With Absolute Difference K",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Number of Possible Root Nodes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Number of Rectangles Containing Each Point",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Count Number of Special Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Number of Teams",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Number of Texts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Number of Trapezoids I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Number of Trapezoids II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Number of Ways to Place Houses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Numbers with Non-Decreasing Digits",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Numbers with Unique Digits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Numbers With Unique Digits II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Occurrences in Text",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Odd Letters from Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Odd Numbers in an Interval Range",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Count of Integers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count of Interesting Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count of Matches in Tournament",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Count of Range Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count of Smaller Numbers After Self",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Count of Sub-Multisets With Bounded Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count of Substrings Containing Every Vowel and K Consonants I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count of Substrings Containing Every Vowel and K Consonants II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Operations to Obtain Zero",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Pairs in Two Arrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Pairs of Connectable Servers in a Weighted Tree Network",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Pairs of Equal Substrings With Minimum Difference",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Pairs Of Nodes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Count Pairs of Points With Distance k",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Pairs Of Similar Strings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Pairs That Form a Complete Day I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Pairs That Form a Complete Day II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Pairs Whose Sum is Less than Target",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Pairs With XOR in a Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Palindromic Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Partitions with Even Sum Difference",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Partitions With Max-Min Difference at Most K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Paths That Can Form a Palindrome in a Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Paths With the Given XOR Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Positions on Street With Required Brightness",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Prefix and Suffix Pairs I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Prefix and Suffix Pairs II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Prefixes of a Given String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Prime-Gap Balanced Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Primes",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Residue Prefixes",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Routes to Climb a Rectangular Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Salary Categories",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Sequences to K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Servers that Communicate",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Smaller Elements With Opposite Parity",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Sorted Vowel Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Special Integers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Special Quadruplets",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Special Subsequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Special Triplets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Square Submatrices with All Ones",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Square Sum Triples",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Stable Subarrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Stepping Numbers in Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Strictly Increasing Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Student Number in Departments",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Sub Islands",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Subarrays of Length Three With a Condition",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Subarrays Where Max Element Appears at Least K Times",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Subarrays With Cost Less Than or Equal to K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Subarrays With Fixed Bounds",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Subarrays With K Distinct Integers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Subarrays With Majority Element I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Subarrays With Majority Element II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Subarrays With Median K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Subarrays With More Ones Than Zeros",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Subarrays With Score Less Than K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Submatrices With All Ones",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Submatrices With Equal Frequency of X and Y",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Submatrices with Top-Left Element and Sum Less Than k",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Substrings Divisible By Last Digit",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Substrings That Can Be Rearranged to Contain a String I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Substrings That Can Be Rearranged to Contain a String II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Substrings That Differ by One Character",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Substrings That Satisfy K-Constraint I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Substrings That Satisfy K-Constraint II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Substrings With K-Frequency Characters I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Substrings With K-Frequency Characters II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Substrings with Only One Distinct Letter",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Count Substrings Without Repeating Character",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Subtrees With Max Distance Between Cities",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Symmetric Integers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Tested Devices After Test Operations",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Digits That Divide a Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Hidden Sequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Arrays with K Matching Adjacent Elements",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Beautiful Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Complete Components",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Computer Unlocking Permutations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Consistent Strings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Experiments",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Fair Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count the Number of Good Nodes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Good Partitions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Good Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count the Number of Good Subsequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Houses at a Certain Distance I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Houses at a Certain Distance II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Ideal Arrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Incremovable Subarrays I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count the Number of Incremovable Subarrays II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count the Number of Infection Sequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Inversions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count the Number of K-Big Indices",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Count the Number of K-Free Subsets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count the Number of Powerful Integers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Special Characters I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Special Characters II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count the Number of Square-Free Subsets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count the Number of Substrings With Dominant Ones",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count the Number of Vowel Strings in Range",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count The Number of Winning Sequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count The Repetitions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Total Number of Colored Cells",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Triplets That Can Form Two Arrays of Equal XOR",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Triplets with Even XOR Set Bits I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Triplets with Even XOR Set Bits II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Unguarded Cells in the Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Unhappy Friends",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Unique Characters of All Substrings of a Given String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Univalue Subtrees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Unreachable Pairs of Nodes in an Undirected Graph",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Valid Paths in a Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Valid Word Occurrences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Visited Nodes in a Directed Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Count Vowel Strings in Ranges",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Vowel Substrings of a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Count Vowels Permutation",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Ways To Build Good Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Ways to Build Rooms in an Ant Colony",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Ways to Choose Coprime Integers from Rows",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Ways to Distribute Candies",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Count Ways to Group Overlapping Ranges",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Ways to Make Array With Product",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Words Obtained After Adding a Letter",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Count Zero Request Servers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Counter",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Counter II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Counting Bits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Counting Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Counting Words With a Given Prefix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Countries You Can Safely Invest In",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Couples Holding Hands",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Coupon Code Validator",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Course Schedule",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Course Schedule II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Course Schedule III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Course Schedule IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Cousins in Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Cousins in Binary Tree II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Cracking the Safe",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Crawler Log Folder",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create a DataFrame from List",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create a New Column",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create a Session Bar Chart",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create Binary Tree From Descriptions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Create Components With Same Value",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create Grid With Exactly K Paths I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create Grid With Exactly K Paths II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create Grid With Exactly One Path",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create Hello World Function",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create Maximum Number",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create Object from Two Arrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Create Sorted Array through Instructions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Create Target Array in the Given Order",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Critical Connections in a Network",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Curry",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Custom Interval",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Custom Sort String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Customer Order Frequency",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Customer Placing the Largest Number of Orders",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Customer Purchasing Behavior Analysis",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Customer Who Visited but Did Not Make Any Transactions",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Customers Who Bought All Products",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Customers Who Bought Products A and B but Not C",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Customers Who Never Order",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Customers with Maximum Number of Transactions on Consecutive Days",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Customers With Strictly Increasing Purchases",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Cut Off Trees for Golf Event",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Cutting Ribbons",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Cycle Length Queries in a Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Cyclically Rotating a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Daily Leads and Partners",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Daily Temperatures",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Data Stream as Disjoint Intervals",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Date Range Generator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Day of the Week",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Day of the Year",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Debounce",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Decode String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Decode the Message",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Decode the Slanted Ciphertext",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Decode Ways",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Decode Ways II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Decode XORed Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Decode XORed Permutation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Decoded String at Index",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Decompress Run-Length Encoded List",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Decrease Elements To Make Array Zigzag",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Decremental String Concatenation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Decrypt String from Alphabet to Integer Mapping",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Deep Merge of Two Objects",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Deep Object Filter",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Deepest Leaves Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Defanging an IP Address",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Defuse the Bomb",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Degree of an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Delay the Resolution of Each Promise",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Delayed Count of Equal Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Delete and Earn",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Delete Characters to Make Fancy String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Delete Columns to Make Sorted",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Delete Columns to Make Sorted II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Delete Columns to Make Sorted III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Delete Duplicate Emails",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Delete Duplicate Folders in System",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Delete Greatest Value in Each Row",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Delete Leaves With a Given Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Delete N Nodes After M Nodes of a Linked List",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Delete Node in a BST",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Delete Node in a Linked List",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Delete Nodes And Return Forest",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Delete Nodes From Linked List Present in Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Delete Operation for Two Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Delete the Middle Node of a Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Delete Tree Nodes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Delivering Boxes from Storage to Ports",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Department Highest Salary",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Department Top Three Salaries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Describe the Painting",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Design a 3D Binary Matrix with Efficient Layer Tracking",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design a File Sharing System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design a Food Rating System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design A Leaderboard",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design a Number Container System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design a Stack With Increment Operation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design a Text Editor",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design a Todo List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design an Array Statistics Tracker",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design an ATM Machine",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design an Expression Tree With Evaluate Function",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design an Ordered Stream",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Auction System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Authentication Manager",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Bitset",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Bounded Blocking Queue",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Concurrency"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Browser History",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Cancellable Function",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Circular Deque",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Circular Queue",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Compressed String Iterator",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Event Manager",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Exam Scores Tracker",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Excel Sum Formula",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design File System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Front Middle Back Queue",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Graph With Shortest Path Calculator",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design HashMap",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design HashSet",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Hit Counter",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design In-Memory File System",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Log Storage System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Memory Allocator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Most Recently Used Queue",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Movie Rental System",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Neighbor Sum Service",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Order Management System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Parking System",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Phone Directory",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Ride Sharing System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Search Autocomplete System",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Skiplist",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Snake Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Spreadsheet",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design SQL",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Task Manager",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Tic-Tac-Toe",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Twitter",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Underground System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Design Video Sharing Platform",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Destination City",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Destroy Sequential Targets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Destroying Asteroids",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Detect Capital",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Detect Cycles in 2D Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Detect Pattern of Length M Repeated K or More Times",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Detect Squares",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Determine Color of a Chessboard Square",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Determine if a Cell Is Reachable at a Given Time",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Determine if a Simple Graph Exists",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Determine if String Halves Are Alike",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Determine if Two Events Have Conflict",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Determine if Two Strings Are Close",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Determine the Minimum Sum of a k-avoiding Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Determine the Winner of a Bowling Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Determine Whether Matrix Can Be Obtained By Rotation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Detonate the Maximum Bombs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Geometry"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "DI String Match",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Diagonal Traverse",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Diagonal Traverse II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Queue"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Diameter of Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Diameter of N-Ary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Dice Roll Simulation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Diet Plan Performance",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Difference Between Element Sum and Digit Sum of an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Difference Between Maximum and Minimum Price Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Difference Between Ones and Zeros in Row and Column",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Difference of Number of Distinct Values on Diagonals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Differences Between Two Objects",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Different Ways to Add Parentheses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Digit Count in Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Digit Frequency Score",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Digit Operations to Make Two Integers Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Dinner Plate Stacks",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Direction Assignments with Exactly K Visible People",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Disconnect Path in a Binary Matrix by at Most One Flip",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Display Table of Food Orders in a Restaurant",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Display the First Three Rows",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distance Between Bus Stops",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distance to a Cycle in Undirected Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Distant Barcodes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Distinct Echo Substrings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Distinct Gate Paths to LCA",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Distinct Numbers in Each Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Distinct Points Reachable After Substring Removal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distinct Prime Factors of Product of Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distinct Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Distinct Subsequences II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Distribute Candies",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distribute Candies Among Children I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distribute Candies Among Children II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distribute Candies Among Children III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distribute Candies to People",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distribute Coins in Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Distribute Elements Into Two Arrays I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distribute Elements Into Two Arrays II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Distribute Money to Maximum Children",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Distribute Repeating Integers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Divide a String Into Groups of Size k",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divide an Array Into Subarrays With Minimum Cost I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divide an Array Into Subarrays With Minimum Cost II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Divide Array in Sets of K Consecutive Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divide Array Into Arrays With Max Difference",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divide Array Into Equal Pairs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divide Array Into Increasing Sequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divide Chocolate",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Divide Intervals Into Minimum Number of Groups",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divide Nodes Into the Maximum Number of Groups",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divide Players Into Teams of Equal Skill",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divide Two Integers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divisible and Non-divisible Sums Difference",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divisible Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Divisor Game",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "DNA Pattern Recognition",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Domino and Tromino Tiling",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Dot Product of Two Sparse Vectors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Dota2 Senate",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Double a Number Represented as a Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Double Modular Exponentiation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Drop Duplicate Rows",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Drop Missing Data",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Drop Type 1 Orders for Customers With Type 0 Orders",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Dungeon Game",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Duplicate Emails",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Duplicate Zeros",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Dynamic Pivoting of a Table",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Dynamic Unpivoting of a Table",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Earliest Finish Time for Land and Water Rides I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Earliest Finish Time for Land and Water Rides II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Earliest Possible Day of Full Bloom",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Earliest Second to Mark Indices I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Earliest Second to Mark Indices II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Earliest Time to Finish One Task",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Eat Pizzas!",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Edit Distance",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Egg Drop With 2 Eggs and N Floors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Election Results",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Element Appearing More Than 25% In Sorted Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Elements in Array After Removing and Replacing Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Eliminate Maximum Number of Monsters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Elimination Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Employee Bonus",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Employee Free Time",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Employee Importance",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Employee Task Duration and Concurrent Tasks",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Employees Earning More Than Their Managers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Employees Project Allocation",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Employees Whose Manager Left the Company",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Employees With Deductions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Employees With Missing Information",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Encode and Decode Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Encode and Decode TinyURL",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Encode N-ary Tree to Binary Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Encode Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Encode String with Shortest Length",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Encrypt and Decrypt Strings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Equal Rational Numbers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Equal Row and Column Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Equal Score Substrings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Equal Sum Arrays With Minimum Number of Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Equal Sum Grid Partition I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Equal Sum Grid Partition II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Equal Tree Partition",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Equalize Strings by Adding or Removing Characters at Ends",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Erect the Fence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Geometry"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Erect the Fence II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Geometry"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Escape a Large Maze",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Escape The Ghosts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Escape the Spreading Fire",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Evaluate Boolean Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Evaluate Boolean Expression",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Evaluate Division",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Evaluate Reverse Polish Notation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Evaluate the Bracket Pairs of a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Evaluate Valid Expressions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Even Odd Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Event Emitter",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Exactly One Consecutive Set Bits Pair",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Exam Room",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Excel Sheet Column Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Excel Sheet Column Title",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Exchange Seats",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Exclusive Time of Functions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Execute Asynchronous Functions in Parallel",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Execute Cancellable Function With Delay",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Execution of All Suffix Instructions Staying in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Existence of a Substring in a String and Its Reverse",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Expression Add Operators",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Expressive Words",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Extra Characters in a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Extract Kth Character From The Rope Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Factor Combinations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Factorial Generator",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Factorial Trailing Zeroes",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fair Candy Swap",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fair Distribution of Cookies",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Falling Squares",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Fancy Sequence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Faulty Keyboard",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Faulty Sensor",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fibonacci Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Fill a Special Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fill Missing Data",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Filling Bookcase Shelves",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Filter Characters by Frequency",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Filter Elements from Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Filter Occupied Intervals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Filter Restaurants by Vegan-Friendly, Price and Distance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Final Array State After K Multiplication Operations I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Final Array State After K Multiplication Operations II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Final Element After Subarray Deletions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Final Prices With a Special Discount in a Shop",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Final Value of Variable After Performing Operations",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find a Corresponding Node of a Binary Tree in a Clone of That Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find a Good Subset of the Matrix",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find a Peak Element II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find a Safe Walk Through a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find a Value of a Mysterious Function Closest to Target",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find Active Users",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find All Anagrams in a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find All Duplicates in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find All Good Indices",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find All Good Strings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find All Groups of Farmland",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find All K-Distant Indices in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find All Lonely Numbers in the Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find All Numbers Disappeared in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find All People With Secret",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find All Possible Recipes from Given Supplies",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find All Possible Stable Binary Arrays I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find All Possible Stable Binary Arrays II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find All The Lonely Nodes",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find All Unique Email Domains",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Anagram Mappings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find And Replace in String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find and Replace Pattern",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Array Given Subset Sums",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Beautiful Indices in the Given Array I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find Beautiful Indices in the Given Array II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find Books with No Available Copies",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Books with Polarized Opinions",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Bottom Left Tree Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Building Where Alice and Bob Can Meet",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Bursty Behavior",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Candidates for Data Scientist Position",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Candidates for Data Scientist Position II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Category Recommendation Pairs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Center of Star Graph",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find Champion I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Champion II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find Churn Risk Customers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Circular Gift Exchange Chains",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Cities in Each State",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Cities in Each State II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Closest Node to Given Two Nodes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find Closest Number to Zero",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Closest Person",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Common Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Common Elements Between Two Arrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Consecutive Integers from a Data Stream",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Consistently Improving Employees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find COVID Recovery Patients",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Critical and Pseudo-Critical Edges in Minimum Spanning Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find Cumulative Salary of an Employee",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Customer Referee",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Customers With Positive Revenue this Year",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Cutoff Score for Each School",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Diameter Endpoints of a Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Distance in a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Drivers with Improved Fuel Efficiency",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Duplicate File in System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Duplicate Subtrees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Edges in Shortest Paths",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find Elements in a Contaminated Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Emotionally Consistent Users",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Eventual Safe States",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Expensive Cities",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find First and Last Position of Element in Sorted Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find First Palindromic String in the Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Followers Count",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Golden Hour Customers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Good Days to Rob the Bank",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Greatest Common Divisor of Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find if Array Can Be Sorted",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Find if Digit Game Can Be Won",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find if Path Exists in Graph",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find in Mountain Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Indices of Stable Mountains",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Indices With Index and Value Difference I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Indices With Index and Value Difference II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Interview Candidates",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Invalid IP Addresses",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find K Closest Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find K Pairs with Smallest Sums",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Find K-Length Substrings With No Repeated Characters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find K-th Smallest Pair Distance",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Kth Bit in Nth Binary String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Kth Character in Expanded String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Kth Largest XOR Coordinate Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Largest Value in Each Tree Row",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Latest Group of Size M",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Latest Salaries",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Leaves of Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Longest Awesome Substring",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Longest Calls",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Longest Self-Contained Substring",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Longest Special Substring That Occurs Thrice I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Longest Special Substring That Occurs Thrice II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Loyal Customers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Lucky Integer in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Maximal Uncovered Ranges",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Maximum Area of a Triangle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Maximum Balanced XOR Subarray Length",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Maximum Non-decreasing Array Length",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find Maximum Number of Non Intersecting Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Maximum Number of String Pairs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Maximum Removals From Source String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find Maximum Value in a Constrained Sequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Median from Data Stream",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Find Median Given Frequency of Numbers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Minimum Cost to Remove Array Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find Minimum Diameter After Merging Two Trees",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Minimum in Rotated Sorted Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Minimum in Rotated Sorted Array II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Minimum Log Transportation Cost",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Minimum Operations to Make All Elements Divisible by Three",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Minimum Time to Finish All Jobs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Minimum Time to Finish All Jobs II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Minimum Time to Reach Last Room I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find Minimum Time to Reach Last Room II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find Mirror Score of a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Missing and Repeated Values",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Missing Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Missing Observations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Mode in Binary Search Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Most Frequent Vowel and Consonant",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find N Unique Integers Sum up to Zero",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Nearest Point That Has the Same X or Y Coordinate",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Nearest Right Node in Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Nth Smallest Integer With K One Bits",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Number of Coins to Place in Tree Nodes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Number of Ways to Reach the K-th Stair",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Numbers with Even Number of Digits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Occurrences of an Element in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Original Array From Doubled Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Overbooked Employees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Overlapping Shifts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Overlapping Shifts II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Palindrome With Fixed Length",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Pattern in Infinite Stream I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Pattern in Infinite Stream II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Peak Calling Hours for Each City",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Peak Element",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Permutation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Pivot Index",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Players With Zero or One Losses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Polygon With the Largest Perimeter",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Positive Integer Solution for a Given Equation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Product Recommendation Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Products of Elements of Big Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Products with Three Consecutive Digits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Products with Valid Serial Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Resultant Array After Removing Anagrams",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Right Interval",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Root of N-Ary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Score of an Array After Marking All Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Servers That Handled Most Number of Requests",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Find Shortest Path with K Hops",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find Smallest Common Element in All Rows",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Smallest Letter Greater Than Target",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Sorted Submatrices With Maximum Element at Most K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find Special Substring of Length K",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Stores with Inventory Imbalance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Students Who Improved",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Students with Study Spiral Pattern",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Subarray With Bitwise OR Closest to K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find Subarrays With Equal Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Subsequence of Length K With the Largest Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Substring With Given Hash Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Subtree Sizes After Changes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Sum of Array Product of Magical Sequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find Target Indices After Sorting Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Find the Array Concatenation Value",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Celebrity",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Child Who Has the Ball After K Seconds",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the City With the Smallest Number of Neighbors at a Threshold Distance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find the Closest Marked Node",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Find the Closest Palindrome",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Count of Good Integers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Count of Monotonic Pairs I",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Count of Monotonic Pairs II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Count of Numbers Which Are Not Special",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find the Degree of Each Vertex",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Derangement of An Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Difference",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Difference of Two Arrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Distance Value Between Two Arrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find the Distinct Difference Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Divisibility Array of a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Duplicate Number",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find the Encrypted String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find The First Player to win K Games in a Row",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Grid of Region Average",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Highest Altitude",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Index of Permutation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find the Index of the Large Integer",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find the Integer Added to Array I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Integer Added to Array II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Find the K-Beauty of a Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the K-or of an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the K-Sum of an Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Find the K-th Character in String Game I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the K-th Character in String Game II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find The K-th Lucky Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Key of the Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Kth Largest Integer in the Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Find the Kth Smallest Sum of a Matrix With Sorted Rows",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Find the Largest Almost Missing Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Largest Palindrome Divisible by K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Last Marked Nodes in Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find The Least Frequent Digit",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Length of the Longest Common Prefix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Level of Tree with Minimum Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Lexicographically Largest String From the Box I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Lexicographically Largest String From the Box II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Lexicographically Smallest Valid Sequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Longest Balanced Substring of a Binary String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find the Longest Equal Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find the Longest Semi-Repetitive Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find the Longest Substring Containing Vowels in Even Counts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Longest Valid Obstacle Course at Each Position",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find the Losers of the Circular Game",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Maximum Achievable Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Maximum Divisibility Score",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Maximum Factor Score of Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Maximum Length of a Good Subsequence I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Maximum Length of a Good Subsequence II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Maximum Length of Valid Subsequence I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Maximum Length of Valid Subsequence II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Maximum Number of Elements in Subset",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Maximum Number of Fruits Collected",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Maximum Number of Marked Indices",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Maximum Sequence Value of Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Maximum Sum of Node Values",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Median of the Uniqueness Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find the Middle Index in Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Minimum Amount of Time to Brew Potions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Minimum and Maximum Number of Nodes Between Critical Points",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Find the Minimum Area to Cover All Ones I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Minimum Area to Cover All Ones II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Minimum Cost Array Permutation",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Minimum Number of Fibonacci Numbers Whose Sum Is K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Minimum Possible Sum of a Beautiful Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Missing IDs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Most Common Response",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the N-th Value After K Seconds",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Number of Copy Arrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Number of Distinct Colors Among the Balls",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Number of Good Pairs I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Number of Good Pairs II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Number of K-Even Arrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Number of Possible Ways for an Event",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Number of Subarrays Where Boundary Elements Are Maximum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Find the Number of Subsequences With Equal GCD",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Number of Ways to Place People I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Find the Number of Ways to Place People II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Find the Number of Winning Players",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Occurrence of First Almost Equal Substring",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find The Original Array of Prefix Xor",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Original Typed String I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Original Typed String II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Peaks",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Pivot Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Power of K-Size Subarrays I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find the Power of K-Size Subarrays II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find the Prefix Common Array of Two Arrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Punishment Number of an Integer",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Quiet Students in All Exams",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Safest Path in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Score Difference in a Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Score of All Prefixes of an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Sequence of Strings Appeared on the Screen",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Shortest Superstring",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Shortest Superstring II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Smallest Balanced Index",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Smallest Divisor Given a Threshold",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find the Start and End Number of Continuous Ranges",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the String with LCP",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Student that Will Replace the Chalk",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Substring With Maximum Cost",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Subtasks That Did Not Execute",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Sum of Encrypted Integers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Sum of Subsequence Powers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Sum of the Power of All Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find the Team Size",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Town Judge",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Value of the Partition",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Find the Width of Columns of a Grid",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Winner of an Array Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Winner of the Circular Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the Winning Player in Coin Game",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find the XOR of Numbers Which Appear Twice",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Third Transaction",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Three Consecutive Integers That Sum to a Given Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Time Required to Eliminate Bacterial Strains",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Top Performing Driver",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Top Scoring Students",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Top Scoring Students II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Total Time Spent by Each Employee",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Trending Hashtags",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Trending Hashtags II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Triangular Sum of an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Two Non-overlapping Sub-arrays Each With Target Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find Unique Binary String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Users with High Token Usage",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Users with Persistent Behavior Patterns",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Users With Valid E-Mails",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Valid Emails",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Valid Matrix Given Row and Column Sums",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Valid Pair of Adjacent Digits in String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Weighted Median Node in Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Find Winner on a Tic Tac Toe Game",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Words Containing Character",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Words That Can Be Formed by Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find X Value of Array I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find X Value of Array II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Find X-Sum of All K-Long Subarrays I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find X-Sum of All K-Long Subarrays II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Find XOR Sum of All Pairs Bitwise AND",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Xor-Beauty of Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Find Zombie Sessions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Finding 3-Digit Even Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Finding MK Average",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Finding Pairs With a Certain Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Finding the Number of Visible Mountains",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Finding the Topic of Each Post",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Finding the Users Active Minutes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Finish Time of Tasks I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Finish Time of Tasks II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "First and Last Call On the Same Day",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "First Bad Version",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "First Completely Painted Row or Column",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "First Day Where You Have Been in All the Rooms",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "First Element with Unique Frequency",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "First Letter Capitalization",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "First Letter Capitalization II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "First Letter to Appear Twice",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "First Matching Character From Both Ends",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "First Missing Positive",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "First Unique Character in a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "First Unique Even Element",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "First Unique Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fix Names in a Table",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fix Product Name Format",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fixed Point",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Fizz Buzz",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fizz Buzz Multithreaded",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Concurrency"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Flatten 2D Vector",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Flatten a Multilevel Doubly Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Flatten Binary Tree to Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Flatten Deeply Nested Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Flatten Nested List Iterator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Flight Occupancy and Waitlist Analysis",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Flip Binary Tree To Match Preorder Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Flip Columns For Maximum Number of Equal Rows",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Flip Equivalent Binary Trees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Flip Game",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Flip Game II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Flip Square Submatrix Vertically",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Flip String to Monotone Increasing",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Flipping an Image",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Flower Planting With No Adjacent",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Form a Chemical Bond",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Form Array by Concatenating Subarrays of Another Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Form Largest Integer With Digits That Add up to Target",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Form Smallest Number From Two Digit Arrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Four Divisors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fraction Addition and Subtraction",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fraction to Recurring Decimal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Freedom Trail",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Frequencies of Shortest Supersequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Frequency Balance Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Frequency of the Most Frequent Element",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Frequency Tracker",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Friday Purchase III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Friday Purchases I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Friday Purchases II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Friend Circles",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Friend Requests I: Overall Acceptance Rate",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Friend Requests II: Who Has the Most Friends",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Friendly Movies Streamed Last Month",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Friends Of Appropriate Ages",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Friends With No Mutual Friends",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Frog Jump",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Frog Jump II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Frog Position After T Seconds",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Fruit Into Baskets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Fruits Into Baskets II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Fruits Into Baskets III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Function Composition",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Furthest Building You Can Reach",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Furthest Point From Origin",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Game of Life",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Game of Nim",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Game Play Analysis I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Game Play Analysis II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Game Play Analysis III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Game Play Analysis IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Game Play Analysis V",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Gas Station",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "GCD of Odd and Even Sums",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "GCD Sort of an Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Generalized Abbreviation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Generate a String With Characters That Have Odd Count",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Generate Binary Strings Without Adjacent Zeros",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Generate Circular Array Values",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Generate Fibonacci Sequence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Generate Parentheses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Generate Random Point in a Circle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Generate Schedule",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Generate Tag for Video Caption",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Generate the Invoice",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Get Biggest Three Rhombus Sums in a Grid",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Get Equal Substrings Within Budget",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Get Highest Answer Rate Question",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Get Maximum in Generated Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Get the Maximum Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Get the Second Most Recent Activity",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Get the Size of a DataFrame",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Get Watched Videos by Your Friends",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Global and Local Inversions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Goal Parser Interpretation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Goat Latin",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Good Indices in a Digit String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Good Subsequence Queries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Grand Slam Titles",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Graph Connectivity With Threshold",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Graph Valid Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Gray Code",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Greatest Common Divisor of Strings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Greatest Common Divisor Traversal",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Greatest English Letter in Upper and Lower Case",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Greatest Sum Divisible by Three",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Grid Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Grid Illumination",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Grid Teleportation Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Group Anagrams",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Group By",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Group Employees of the Same Salary",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Group Shifted Strings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Group Sold Products By The Date",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Group the People Given the Group Size They Belong To",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Groups of Special-Equivalent Strings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Groups of Strings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Grumpy Bookstore Owner",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Guess Number Higher or Lower",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Guess Number Higher or Lower II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Guess the Majority in a Hidden Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Guess the Number Using Bitwise Questions I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Guess the Number Using Bitwise Questions II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Guess the Word",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "H-Index",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "H-Index II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Hamming Distance",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Hand of Straights",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Handling Sum Queries After Update",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Handshakes That Don't Cross",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Happy Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Happy Students",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Harshad Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Hash Divided String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Heaters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Height Checker",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Height of Binary Tree After Subtree Removal Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Height of Special Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Hexadecimal and Hexatrigesimal Conversion",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Hexspeak",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "High Five",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "High-Access Employees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Highest Grade For Each Student",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Highest Salaries Difference",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Hopper Company Queries I",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Hopper Company Queries II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Hopper Company Queries III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "House Robber",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "House Robber II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "House Robber III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "House Robber IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "House Robber V",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "How Many Apples Can You Put into the Basket",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "How Many Numbers Are Smaller Than the Current Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "HTML Entity Parser",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Human Traffic of Stadium",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Identify the Largest Outlier in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Image Overlap",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Image Smoother",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Immediate Food Delivery I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Immediate Food Delivery II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Immediate Food Delivery III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Immutability Helper",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Implement Magic Dictionary",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Implement Queue using Stacks",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Implement Rand10() Using Rand7()",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Implement Router",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Implement Stack using Queues",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Implement strStr()",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Implement Trie (Prefix Tree)",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Implement Trie II (Prefix Tree)",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Increasing Decreasing String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Increasing Order Search Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Increasing Subsequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Increasing Triplet Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Increment Submatrices by One",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Incremental Even-Weighted Cycle Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Incremental Memory Leak",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Index Pairs of a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Infinite Method Object",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Inorder Successor in BST",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Inorder Successor in BST II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Insert Delete GetRandom O(1)",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Insert Delete GetRandom O(1) - Duplicates allowed",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Insert Greatest Common Divisors in Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Insert Interval",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Insert into a Binary Search Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Insert into a Sorted Circular Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Insertion Sort List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Insufficient Nodes in Root to Leaf Paths",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Integer Break",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Integer Replacement",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Integer to English Words",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Integer to Roman",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Integers With Multiple Sum of Two Cubes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Interleaving String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Intersection of Multiple Arrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Intersection of Three Sorted Arrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Intersection of Two Arrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Intersection of Two Arrays II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Intersection of Two Linked Lists",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Interval Cancellation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Interval List Intersections",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Intervals Between Identical Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Invalid Transactions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Invalid Tweets",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Invalid Tweets II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Inverse Coin Change",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Inversion of Object",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Invert Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Investments in 2016",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "IP to CIDR",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "IPO",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "is Array a Preorder of Some ‌Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Is Graph Bipartite?",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Is Object Empty",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Is Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Island Perimeter",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Isomorphic Strings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Iterator for Combination",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Jewels and Stones",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Join Two Arrays by ID",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "JSON Deep Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Jump Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Jump Game II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Jump Game III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Jump Game IV",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Jump Game IX",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Jump Game V",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Jump Game VI",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Queue"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Jump Game VII",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Jump Game VIII",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "K Closest Points to Origin",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "K Divisible Elements Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "K Empty Slots",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "K Highest Ranked Items Within a Price Range",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "K Inverse Pairs Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "K Items With the Maximum Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "K Radius Subarray Averages",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "K-Concatenation Maximum Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "K-diff Pairs in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "K-Similar Strings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "K-th Largest Perfect Subtree Size in Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "K-th Nearest Obstacle Queries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "K-th Smallest in Lexicographical Order",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "K-th Smallest Prime Fraction",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "K-th Smallest Remaining Even Integer in Subarray Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "K-th Symbol in Grammar",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Keep Multiplying Found Values by Two",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Keyboard Row",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Keys and Rooms",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Kids With the Greatest Number of Candies",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Kill Process",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Knight Dialer",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Knight Probability in Chessboard",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Koko Eating Bananas",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Kth Ancestor of a Tree Node",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Kth Distinct String in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Kth Largest Element in a Stream",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Kth Largest Element in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Kth Largest Sum in a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Kth Missing Positive Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Kth Smallest Amount With Single Denomination Combination",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Kth Smallest Element in a BST",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Kth Smallest Element in a Sorted Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Kth Smallest Instructions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Kth Smallest Number in Multiplication Table",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Kth Smallest Path XOR Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Kth Smallest Product of Two Sorted Arrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Kth Smallest Subarray Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Largest 1-Bordered Square",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Largest 3-Same-Digit Number in String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest BST Subtree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Color Value in a Directed Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Largest Combination With Bitwise AND Greater Than Zero",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Component Size by Common Factor",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Divisible Subset",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Largest Element in an Array after Merge Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Even Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Local Values in a Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Local Values in a Matrix II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Magic Square",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Merge Of Two Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Multiple of Three",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Largest Number After Digit Swaps by Parity",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Largest Number After Mutating Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Number At Least Twice of Others",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Odd Number in String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Palindrome Product",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Palindromic Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Perimeter Triangle",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Largest Plus Sign",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Largest Positive Integer That Exists With Its Negative",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Prime from Consecutive Prime Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Rectangle in Histogram",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Largest Subarray Length K",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Submatrix With Rearrangements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Substring Between Two Equal Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Sum of Averages",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Largest Time for Given Digits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Triangle Area",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Unique Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Largest Values From Labels",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Last Day Where You Can Still Cross",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Last Moment Before All Ants Fall Out of a Plank",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Last Person to Fit in the Elevator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Last Remaining Integer After Alternating Deletion Operations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Last Stone Weight",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Last Stone Weight II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Last Substring in Lexicographical Order",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Last Visited Integers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Latest Time by Replacing Hidden Digits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Latest Time You Can Obtain After Replacing Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Leaf-Similar Trees",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "League Statistics",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Least Number of Unique Integers after K Removals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Least Operators to Express Number",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Leetcodify Friends Recommendations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Leetcodify Similar Friends",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Leetflex Banned Accounts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Left and Right Sum Differences",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Leftmost Column with at Least a One",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lemonade Change",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Length of Last Word",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Length of Longest Fibonacci Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Length of Longest Subarray With at Most K Frequency",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Length of Longest V-Shaped Diagonal Segment",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Length of the Longest Alphabetical Continuous Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Length of the Longest Increasing Path",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Length of the Longest Subsequence That Sums to Target",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Length of the Longest Valid Substring",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Letter Case Permutation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Letter Combinations of a Phone Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Letter Tile Possibilities",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographical Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Maximum MEX Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Minimum String After Removing Stars",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest Beautiful String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest Equivalent String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest Generated String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest Negated Permutation that Sums to Target",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest Palindrome",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest Palindromic Permutation Greater Than Target",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest Permutation Greater Than Target",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest String After a Swap",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest String After Adjacent Removals",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest String After Applying Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest String After Deleting Duplicate Characters",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest String After Operations With Constraint",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest String After Reverse",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest String After Reverse II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Lexicographically Smallest String After Substring Operation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "LFU Cache",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Library Late Fee Calculator",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "License Key Formatting",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Limit Occurrences in Sorted Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Line Reflection",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Linked List Components",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Linked List Cycle",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Linked List Cycle II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Linked List Frequency",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Linked List in Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Linked List Random Node",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "List the Products Ordered in a Period",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Loan Types",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Logger Rate Limiter",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Logical OR of Two Binary Grids Represented as Quad-Trees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Lonely Pixel I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lonely Pixel II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Long Pressed Name",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longer Contiguous Segments of Ones than Zeros",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Absolute File Path",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Almost-Palindromic Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Longest Alternating Subarray",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Alternating Subarray After Removing At Most One Element",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Arithmetic Sequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Arithmetic Sequence After Changing At Most One Element",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Longest Arithmetic Subsequence of Given Difference",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Balanced Subarray I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Balanced Subarray II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Balanced Substring After One Swap",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Balanced Substring I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Balanced Substring II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Binary Subsequence Less Than or Equal to K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Chunked Palindrome Decomposition",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Common Prefix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Common Prefix After at Most One Removal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Longest Common Prefix Between Adjacent Strings After Removals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Common Prefix of K Strings After Removal",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Longest Common Subpath",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Common Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Common Subsequence Between Sorted Arrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Common Suffix Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Consecutive Sequence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Continuous Increasing Subsequence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Continuous Subarray With Absolute Diff Less Than or Equal to Limit",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Queue"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Longest Cycle in a Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Longest Duplicate Substring",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Longest Even Odd Subarray With Threshold",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Fibonacci Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Happy Prefix",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Happy String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Harmonious Subsequence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Ideal Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Increasing Path in a Matrix",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Increasing Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Longest Increasing Subsequence II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Line of Consecutive One in Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Mountain in Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Nice Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Longest Nice Substring",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Non-Decreasing Subarray After Replacing at Most One Element",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Non-decreasing Subarray From Two Arrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Palindrome",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Palindrome After Substring Concatenation I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Palindrome After Substring Concatenation II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Palindrome by Concatenating Two Letter Words",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Palindromic Path in Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Palindromic Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Palindromic Subsequence After at Most K Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Palindromic Subsequence II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Palindromic Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Path With Different Adjacent Characters",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Repeating Character Replacement",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Longest Repeating Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Longest Semi-Repeating Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Longest Special Path",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Longest Special Path II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Longest Square Streak in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Strictly Increasing or Strictly Decreasing Subarray",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Strictly Increasing Subsequence With Non-Zero Bitwise AND",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Longest String Chain",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Subarray of 1's After Deleting One Element",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Longest Subarray With Maximum Bitwise AND",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Subsequence Repeated k Times",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Subsequence With Decreasing Adjacent Difference",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Subsequence With Limited Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Longest Subsequence With Non-Zero Bitwise XOR",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Substring Of All Vowels in Order",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Substring of One Repeating Character",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Substring with At Least K Repeating Characters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Substring with At Most K Distinct Characters",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Substring with At Most Two Distinct Characters",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Substring Without Repeating Characters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Team Pass Streak",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Turbulent Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Uncommon Subsequence I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Uncommon Subsequence II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Unequal Adjacent Groups Subsequence I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Unequal Adjacent Groups Subsequence II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Longest Univalue Path",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Longest Uploaded Prefix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Valid Parentheses",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Longest Well-Performing Interval",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Winning Streak",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Word in Dictionary",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Word in Dictionary through Deleting",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest Word With All Prefixes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Longest ZigZag Path in a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Loud and Rich",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Low-Quality Problems",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lowest Common Ancestor of a Binary Search Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Lowest Common Ancestor of a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lowest Common Ancestor of a Binary Tree II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lowest Common Ancestor of a Binary Tree III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Lowest Common Ancestor of a Binary Tree IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lowest Common Ancestor of Deepest Leaves",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "LRU Cache",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Lucky Numbers in a Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Magic Squares In Grid",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Magical String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Magnetic Force Between Two Balls",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Majority Element",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Majority Element II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Majority Frequency Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make a Positive Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make a Square with the Same Color",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make Array Elements Equal to Zero",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make Array Empty",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Make Array Non-decreasing",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make Array Non-decreasing or Non-increasing",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make Array Strictly Increasing",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Make Array Zero by Subtracting Equal Amounts",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make Costs of Paths Equal in a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make K-Subarray Sums Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make Lexicographically Smallest Array by Swapping Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Make Number of Distinct Characters Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make Object Immutable",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make String a Subsequence Using Cyclic Increments",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make String Anti-palindrome",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make Sum Divisible by P",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make the Prefix Sum Non-negative",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make The String Great",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make the XOR of All Segments Equal to Zero",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Make Three Strings Equal",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Make Two Arrays Equal by Reversing Sub-arrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Making A Large Island",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Making File Names Unique",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Manager of the Largest Department",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Managers with at Least 5 Direct Reports",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Manhattan Distances of All Arrangements of Pieces",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Map of Highest Peak",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Map Sum Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Mark Elements on Array by Performing Queries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Market Analysis I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Market Analysis II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Market Analysis III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Masking Personal Information",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Match Alphanumerical Pattern in Matrix I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Match Substring After Replacement",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Matchsticks to Square",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Matrix Block Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Matrix Cells in Distance Order",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Matrix Diagonal Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Matrix Similarity After Cyclic Shifts",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Area of Island",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Chunks To Make Sorted",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Chunks To Make Sorted II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Consecutive Ones",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Consecutive Ones II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Consecutive Ones III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Max Difference You Can Get From Changing an Integer",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Dot Product of Two Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Max Increase to Keep City Skyline",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Number of K-Sum Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Pair Sum in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Points on a Line",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Stack",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Sum of a Pair With Equal Sum of Digits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Max Sum of Rectangle No Larger Than K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Max Value of Equation",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Queue"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximal Network Rank",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximal Range That Each Element Is Maximum in It",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximal Rectangle",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximal Score After Applying K Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximal Square",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximize Active Section with Trade I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Active Section with Trade II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Alternating Sum Using Swaps",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Amount After Two Days of Conversions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximize Area of Square Hole in Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Consecutive Elements in an Array After Modification",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximize Count of Distinct Primes After Split",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Cyclic Partition Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximize Distance to Closest Person",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Expression of Three Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Fixed Points After Deletions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximize Greatness of an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Grid Happiness",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Happiness of Selected Children",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Items",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Number of Nice Divisors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Number of Subsequences in a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Palindrome Length From Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximize Points After Choosing K Tasks",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Profit from Task Assignment",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Score After N Operations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximize Score After Pair Deletions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Score of Numbers in Ranges",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximize Spanning Tree Stability with Upgrades",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximize Subarray GCD Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximize Subarray Sum After Removing All Occurrences of One Element",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Subarrays After Removing One Conflicting Pair",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Sum Of Array After K Negations",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Sum of At Most K Distinct Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximize Sum of Device Ratings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Sum of Squares of Digits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Sum of Weights after Edge Removals",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize the Beauty of the Garden",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize the Confusion of an Exam",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximize the Distance Between Points on a Square",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximize the Minimum Game Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximize the Minimum Powered City",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximize the Number of Partitions After Operations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize the Number of Target Nodes After Connecting Trees I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximize the Number of Target Nodes After Connecting Trees II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize the Profit as the Salesman",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximize the Topmost Element After K Moves",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize the Total Height of Unique Towers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximize Total Cost of Alternating Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximize Total Tastiness of Purchased Fruits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximize Value of Function in a Ball Passing Game",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximize Win From Two Segments",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximize Y‑Sum by Picking a Triplet of Distinct X‑Values",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum 69 Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Absolute Sum of Any Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Alternating Subarray Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Alternating Subsequence Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Alternating Sum of Squares",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Amount of Money Robot Can Earn",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum and Minimum Sums of at Most Size K Subarrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum and Minimum Sums of at Most Size K Subsequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum AND Sum of Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Area of a Piece of Cake After Horizontal and Vertical Cuts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Area of Longest Diagonal Rectangle",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Area Rectangle With Point Constraints I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Area Rectangle With Point Constraints II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Array Hopping Score I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Array Hopping Score II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Ascending Subarray Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Average Pass Ratio",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Average Subarray I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Average Subarray II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Average Subtree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Bags With Full Capacity of Rocks",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Balanced Shipments",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Balanced Subsequence Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Beauty of an Array After Applying Operation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Binary String After Change",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Binary Tree II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Bitwise AND After Increment Operations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Bitwise XOR After Rearrangement",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Building Height",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Calories Burnt from Jumps",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Candies Allocated to K Children",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Candies You Can Get from Boxes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Capacity Within Budget",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Coin Collection",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Coins From K Consecutive Bags",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Coins Heroes Can Collect",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Compatibility Score Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Consecutive Floors Without Special Floors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Consistent Columns in a Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Containers on a Ship",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Cost of Trip With K Highways",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Count of Positive Integer and Negative Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Deletions on a String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Depth of Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Difference Between Adjacent Elements in a Circular Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Difference Between Even and Odd Frequency I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Difference Between Even and Odd Frequency II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Difference Between Increasing Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Difference Between Node and Ancestor",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Difference by Remapping a Digit",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Difference Score in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Distance Between a Pair of Values",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Distance Between Unequal Words in Array I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Distance Between Unequal Words in Array II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Distance in Arrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Distinct Path Sum in a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Earnings From Taxi",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Elegance of a K-Length Subsequence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Element After Decreasing and Rearranging",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Element-Sum of a Complete Subset of Indices",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Employees to Be Invited to a Meeting",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Enemy Forts That Can Be Captured",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Energy Boost From Two Drinks",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Equal Frequency",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Erasure Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Font to Fit a Sentence in a Screen",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Frequency After Subarray Operation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Frequency of an Element After Performing Operations I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Frequency of an Element After Performing Operations II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Frequency Score of a Subarray",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Frequency Stack",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Fruits Harvested After at Most K Steps",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Gap",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Maximum GCD-Sum of a Subarray",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Genetic Difference Query",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Good People Based on Statements",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Good Subarray Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Good Subtree Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Hamming Distances",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Height by Stacking Cuboids",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Height of a Triangle",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Ice Cream Bars",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Increasing Triplet Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum K to Sort a Permutation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Maximum Length of a Concatenated String with Unique Characters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Length of Pair Chain",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Length of Repeated Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Length of Semi-Decreasing Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Length of Subarray With Positive Product",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Length Substring With Two Occurrences",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Level Sum of a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Linear Stock Score",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Manhattan Distance After All Moves",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Manhattan Distance After K Changes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Matching of Players With Trainers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Matrix Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Median Sum of Subsequences of Size 3",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Multiplication Score",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Nesting Depth of the Parentheses",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Nesting Depth of Two Valid Parentheses Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Non Negative Product in a Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Number of Accepted Invitations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Number of Achievable Transfer Requests",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Number of Alloys",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Balloons",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Balls in a Box",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Books You Can Take",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Number of Coins You Can Get",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Maximum Number of Consecutive Values You Can Make",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Darts Inside of a Circular Dartboard",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Geometry"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Distinct Elements After Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Eaten Apples",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Equal Length Runs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Events That Can Be Attended",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Events That Can Be Attended II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Number of Fish in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Groups Entering a Competition",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Groups Getting Fresh Donuts",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Groups With Increasing Length",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Integers to Choose From a Range I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Number of Integers to Choose From a Range II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Number of Intersections on the Chart",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Items From Sale I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Number of Items From Sale II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Jumps to Reach the Last Index",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Number of K-Divisible Components",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Matching Indices After Right Shifts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Moves in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Number of Moves to Kill All Pawns",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Number of Non-overlapping Palindrome Substrings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Non-Overlapping Subarrays With Sum Equals Target",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Non-Overlapping Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Occurrences of a Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Number of Ones",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Operations to Move Ones to the End",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Operations With the Same Score I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Operations With the Same Score II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Number of Pairs in Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of People That Can Be Caught in Tag",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Number of Points From Grid Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Points with Cost",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Number of Potholes That Can Be Fixed",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Removable Characters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Number of Removal Queries That Can Be Processed I",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Number of Robots Within Budget",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Queue"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Number of Subsequences After One Inserting",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Number of Tasks You Can Assign",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Upgradable Servers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Visible Points",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Geometry"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Vowels in a Substring of Given Length",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Number of Ways to Partition an Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Weeks for Which You Can Work",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Words Found in Sentences",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number of Words You Can Type",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number That Makes Result of Bitwise AND Zero",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Number That Sum of the Prices Is Less Than or Equal to K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Odd Binary Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum of Absolute Value Expression",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum of Minimum Values in All Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum OR",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Palindromes After Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Partition Factor",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Path Intersection Sum in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Path Quality of a Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Path Score in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Performance of a Team",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Points Activated with One Addition",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Points After Collecting Coins From All Nodes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Points After Enemy Battles",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Points in an Archery Competition",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Points Inside the Square",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Points Tourist Can Earn",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Points You Can Obtain from Cards",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Population Year",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Possible Number by Binary Concatenation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Maximum Price to Fill a Bag",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Prime Difference",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Product After K Increments",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Maximum Product Difference Between Two Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Product of First and Last Elements of a Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Product of Splitted Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Product of Subsequences With an Alternating Sum Equal to K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Product of the Length of Two Palindromic Subsequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Product of the Length of Two Palindromic Substrings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Product of Three Elements After One Replacement",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Product of Three Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Product of Two Digits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Product of Two Elements in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Product of Two Integers With No Common Bits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Product of Word Lengths",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Product Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Profit From Trading Stocks",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Profit from Trading Stocks with Discounts",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Profit from Valid Topological Order in DAG",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Profit in Job Scheduling",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Profit of Operating a Centennial Wheel",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Profitable Triplets With Increasing Prices I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Profitable Triplets With Increasing Prices II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Repeating Substring",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Requests Without Violating the Limit",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Rows Covered by Columns",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Running Time of N Computers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Score After Applying Operations on a Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Score After Binary Swaps",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Score After Splitting a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Score From Grid Operations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Score from Performing Multiplication Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Score From Removing Stones",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Score From Removing Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Score of a Good Subarray",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Score of a Node Sequence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Score of a Split",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Score of Non-overlapping Intervals",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Score Of Spliced Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Score Using Exactly K Pairs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Score with Co-Prime Element",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Score Words Formed by Letters",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Segment Sum After Removals",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Side Length of a Square with Sum Less than or Equal to Threshold",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Size of a Set After Removals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Size Subarray Sum Equals k",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Sized Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Split of Positive Even Integers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Square Area by Removing Fences From a Field",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Star Sum of a Graph",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Maximum Strength of a Group",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Strength of K Disjoint Subarrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Strictly Increasing Cells in a Matrix",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Strong Pair XOR I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Strong Pair XOR II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Students on a Single Bench",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Students Taking Exam",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Subarray",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Subarray Min-Product",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Subarray Sum After at Most K Swaps",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Subarray Sum After Multiplier",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Subarray Sum After One Operation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Subarray Sum With Length Divisible by K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Subarray Sum with One Deletion",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Subarray With Equal Products",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Subarray XOR with Bounded Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Subgraph Score in a Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Subsequence Score",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Substrings With Distinct Start",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Subtree of the Same Color",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Sum BST in Binary Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Sum Circular Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Sum Obtained of Any Permutation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Sum of 3 Non-Overlapping Subarrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Sum of Almost Unique Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Sum of Alternating Subsequence With Distance at Least K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Sum of an Hourglass",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Sum of Distinct Subarrays With Length K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Sum of Edge Values in a Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Maximum Sum of M Non-Overlapping Subarrays I",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Sum of M Non-Overlapping Subarrays II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Sum of Subsequence With Non-adjacent Elements",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Sum of Three Numbers Divisible by Three",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Maximum Sum of Two Non-Overlapping Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Sum Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Sum Score of Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Sum With at Most K Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Sum With Exactly K Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Swap",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Tastiness of Candy Basket",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Team Size with Overlapping Intervals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Total Area Occupied by Pistons",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Total Beauty of the Gardens",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Maximum Total Damage With Spell Casting",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Total from Optimal Activation Order",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Total Importance of Roads",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Total Reward Using Operations I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Total Reward Using Operations II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Total Subarray Value I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Total Subarray Value II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Total Sum of K Selected Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Total Sum with Threshold Constraints",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Total Value",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Total Value of Covered Indices",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Trailing Zeros in a Cornered Path",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Transaction Each Day",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Transactions Without Negative Balance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Twin Sum of a Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Maximum Unique Subarray Sum After Deletion",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Units on a Truck",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Vacation Days",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Valid Pair Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Value after Insertion",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Value at a Given Index in a Bounded Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Value of a String in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Value of an Ordered Triplet I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Value of an Ordered Triplet II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Value of Concatenated Binary Segments",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Value of K Coins From Piles",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Value Sum by Placing Three Rooks I",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Value Sum by Placing Three Rooks II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Maximum Walls Destroyed by Robots",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Weight in Two Bags",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum Weighted K-Edge Path",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum White Tiles Covered by a Carpet",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Width of Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Maximum Width Ramp",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum XOR After Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum XOR for Each Query",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum XOR of Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum XOR of Two Non-Overlapping Subtrees",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum XOR of Two Numbers in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum Xor Product",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Maximum XOR Score Subarray Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Maximum XOR With an Element From Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Mean of Array After Removing Some Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Median Employee Salary",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Median of a Binary Search Tree Level",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Median of a Row Wise Sorted Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Median of Two Sorted Arrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Meeting Rooms",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Meeting Rooms II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Meeting Rooms III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Meeting Scheduler",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Memoize",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Memoize II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Merge Adjacent Equal Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Merge BSTs to Create Single BST",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Merge Close Characters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Merge In Between Linked Lists",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Merge Intervals",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Merge k Sorted Lists",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Merge Nodes in Between Zeros",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Merge Operations for Minimum Travel Time",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Merge Operations to Turn Array Into a Palindrome",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Merge Overlapping Events in the Same Hall",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Merge Similar Items",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Merge Sorted Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Merge Strings Alternately",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Merge Triplets to Form Target Triplet",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Merge Two 2D Arrays by Summing Values",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Merge Two Binary Trees",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Merge Two Sorted Lists",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Method Chaining",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Mice and Cheese",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Middle of the Linked List",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Min Cost Climbing Stairs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Min Cost to Connect All Points",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Min Max Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Min Stack",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minesweeper",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Mini Parser",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimize Array Sum Using Divisible Replacements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize Connected Groups by Inserting Interval",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimize Deviation in Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimize Hamming Distance After Swap Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize Length of Array Using Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize Malware Spread",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimize Malware Spread II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimize Manhattan Distances",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize Max Distance to Gas Station",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimize Maximum Component Cost",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize Maximum of Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize Maximum Pair Sum in Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize Maximum Value in a Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize OR of Remaining Elements Using Operations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize Product Sum of Two Arrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize Result by Adding Parentheses to Expression",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize Rounding Error to Meet Target",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize String Length",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimize the Difference Between Target and Chosen Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimize the Maximum Adjacent Element Difference",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimize the Maximum Difference of Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimize the Maximum Edge Weight of Graph",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimize the Maximum of Two Arrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimize the Total Price of the Trips",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimize XOR",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimized Maximum of Products Distributed to Any Store",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimizing Array After Replacing Pairs With Their Product",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Absolute Difference",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Absolute Difference Between Elements With Constraint",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Absolute Difference Between Two Values",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Absolute Difference in BST",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Absolute Difference in Sliding Submatrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Absolute Difference Queries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Absolute Distance Between Mirror Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Absolute Sum Difference",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Add to Make Parentheses Valid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimum Addition to Make Integer Beautiful",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Additions to Make Valid String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Adjacent Swaps for K Consecutive Ones",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Minimum Adjacent Swaps to Alternate Parity",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Adjacent Swaps to Make a Valid Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Adjacent Swaps to Reach the Kth Smallest Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Amount of Damage Dealt to Bob",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Amount of Time to Collect Garbage",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Amount of Time to Fill Cups",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Area Rectangle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Area Rectangle II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Array Changes to Make Differences Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Array End",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Array Length After Pair Removals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Array Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum ASCII Delete Sum for Two Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Average Difference",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Average of Smallest and Largest Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Minimum Bit Flips to Convert Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Bitwise OR From Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Capacity Box",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Changes To Make Alternating Binary String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Changes to Make K Semi-palindromes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Common Value",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Consecutive Cards to Pick Up",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost for Cutting Cake I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost for Cutting Cake II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost For Tickets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost Good Caption",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost Homecoming of a Robot in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost of a Path With Special Roads",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Cost of Buying Candies With Discount",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost Path with Alternating Directions I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost Path with Alternating Directions II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost Path with Edge Reversals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Cost Path with Teleportations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Acquire Required Items",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Buy Apples",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Buy Apples II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Change the Final Value of Expression",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Connect Sticks",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Connect Two Groups of Points",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Convert String I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Convert String II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Cut a Stick",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Divide Array Into Subarrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Equalize Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Equalize Arrays Using Swaps",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Hire K Workers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Make All Characters Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Make Array Equal",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Make Array Equalindromic",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Make Arrays Identical",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Make at Least One Valid Path in a Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Make Two Binary Strings Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Merge Sorted Lists",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Merge Stones",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Move Between Indices",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Partition a Binary String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Reach Destination in Time",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Reach Every Position",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Repair Edges to Traverse a Graph",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Separate Sentence Into Rows",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Set Cooking Time",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Split an Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Split into Ones",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost to Split into Ones II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Cost Tree From Leaf Values",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimum Cost Walk in Weighted Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Costs Using the Train Line",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Cuts to Divide a Circle",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Degree of a Connected Trio in a Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Deletion Cost to Avoid Repeating Letters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Deletion Cost to Make All Characters Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Deletions for At Most K Distinct Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Deletions to Make Alternating Substring",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Deletions to Make Array Beautiful",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Deletions to Make Array Divisible",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Deletions to Make Character Frequencies Unique",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Deletions to Make String Balanced",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Deletions to Make String K-Special",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Depth of Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Difference Between Highest and Lowest of K Scores",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Difference Between Largest and Smallest Value in Three Moves",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Minimum Difference in Sums After Removal of Elements",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimum Difficulty of a Job Schedule",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Discards to Balance Inventory",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Distance Between BST Nodes",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Distance Between Three Equal Elements I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Distance Between Three Equal Elements II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Distance Excluding One Maximum Weighted Edge",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Distance to the Target Element",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Distance to Type a Word Using Two Fingers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Division Operations to Make Array Non Decreasing",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Domino Rotations For Equal Row",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Edge Reversals So Every Node Is Reachable",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Edge Toggles on a Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Edge Weight Equilibrium Queries in a Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Element After Replacement With Digit Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Elements to Add to Form a Given Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Energy to Maintain Brightness",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Equal Sum of Two Arrays After Replacing Zeros",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Factorization",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Falling Path Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Falling Path Sum II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Flips in Binary Tree to Get Result",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Flips to Make a OR b Equal to c",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Flips to Make Binary String Coherent",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Fuel Cost to Report to the Capital",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Garden Perimeter to Collect Enough Apples",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Generations to Target Point",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Genetic Mutation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Health to Beat Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Height Trees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Hours of Training to Win a Competition",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Impossible OR",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Incompatibility",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Increase to Maximize Special Indices",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Increment Operations to Make Array Beautiful",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Increment to Make Array Unique",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Increments for Target Multiples in an Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Increments to Equalize Leaf Paths",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Index of a Valid Split",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Index Sum of Common Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Index Sum of Two Lists",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Initial Energy to Finish Tasks",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Insertion Steps to Make a String Palindrome",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Insertions to Balance a Parentheses String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimum Interval to Include Each Query",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Minimum Inversion Count in Subarrays of Fixed Length",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Jumps to Reach End via Prime Teleportation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Jumps to Reach Home",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum K to Reduce Array Within Limit",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Knight Moves",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Length of Anagram Concatenation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Length of String After Deleting Similar Ends",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Length of String After Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Levels to Gain More Points",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Lights to Illuminate a Road",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Limit of Balls in a Bag",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Lines to Represent a Line Chart",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Money Required Before Transactions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Balance Circular Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Capture The Queen",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Clean the Classroom",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Convert String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Equal Array Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Equal Array Elements II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Equal Array Elements III",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Get a Peaceful Board",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Move a Box to Their Target Location",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Pick K Ones",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Reach Target in Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Reach Target Score",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Reach Target with Rotations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Moves to Spread Stones Over Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Non-Zero Product of the Array Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number Game",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Minimum Number of Arrows to Burst Balloons",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Buckets Required to Collect Rainwater from Houses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Chairs in a Waiting Room",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Changes to Make Binary String Beautiful",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Coins for Fruits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Number of Coins for Fruits II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Number of Coins to be Added",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Days to Disconnect Island",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Number of Days to Eat N Oranges",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Number of Days to Make m Bouquets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Number of Flips to Convert Binary Matrix to Zero Matrix",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Flips to Make Binary Grid Palindromic I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Flips to Make Binary Grid Palindromic II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Flips to Make the Binary String Alternatings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Number of Flips to Reverse Binary String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Frogs Croaking",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Groups to Create a Valid Assignment",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Increasing Subsequence to Be Removed",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Number of Increments on Subarrays to Form a Target Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of K Consecutive Bit Flips",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Keypresses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Lines to Cover Points",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Moves to Make Palindrome",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Moves to Seat Everyone",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Convert Time",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Have Distinct Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Make All Array Elements Equal to 1",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Make Array Continuous",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Make Array Empty",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Make Array XOR Equal to K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Make Arrays Similar",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Make Elements in Array Distinct",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Make String Sorted",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Make Word K-Periodic",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Make X and Y Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Move All Balls to Each Box",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Reinitialize a Permutation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Satisfy Conditions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Number of Operations to Sort a Binary Tree by Level",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of People to Teach",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Primes to Sum to Target",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Number of Pushes to Type Word I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Pushes to Type Word II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Refueling Stops",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimum Number of Removals to Make Mountain Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Number of Seconds to Make Mountain Height Zero",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Number of Steps to Make Two Strings Anagram",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Steps to Make Two Strings Anagram II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Swaps to Make the Binary String Alternating",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Swaps to Make the String Balanced",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Taps to Open to Water a Garden",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Valid Strings to Form Target I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Number of Valid Strings to Form Target II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Number of Vertices to Reach All Nodes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Number of Visited Cells in a Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Number of Work Sessions to Finish the Tasks",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Numbers of Function Calls to Make Target Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Obstacle Removal to Reach Corner",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum One Bit Operations to Make Integers Zero",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Achieve At Least K Peaks",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Collect Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Convert All Elements to Zero",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Convert Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Equalize Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Equalize Binary String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Equalize Subarrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Exceed Threshold Value I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Exceed Threshold Value II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Form Subsequence With Target Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Halve Array Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make a Special Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make a Subsequence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make a Uni-Value Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make All Array Elements Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make All Grid Elements Equal",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Array Elements Zero",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Array Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Array Equal II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Array Equal to Target",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Array Modulo Alternating I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Array Modulo Alternating II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Array Non Decreasing",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Array Parity Alternating",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Array Sum Divisible by K",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Array Values Equal to K",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Binary Array Elements Equal to One I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Binary Array Elements Equal to One II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Binary Palindrome",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Character Frequencies Equal",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Columns Strictly Increasing",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Elements Within K Subarrays Equal",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Median of Array Equal to K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Numbers Non-positive",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make Subarray Elements Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make the Array Alternating",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make the Array Beautiful",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make the Array Increasing",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make the Array K-Increasing",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Make the Integer Zero",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Maximize Last Elements in Arrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Reach Target Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Reduce an Integer to 0",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Reduce X to Zero",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Remove Adjacent Ones in Matrix",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Sort a Permutation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Sort a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Transform Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Transform Binary String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Transform String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Operations to Write the Letter Y on a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Pair Removal to Sort Array I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Pair Removal to Sort Array II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Partition Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Partition Score II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Path Cost in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Path Cost in a Hidden Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Path Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Penalty for a Shop",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Positive Sum Subarray",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Possible Integer After at Most K Adjacent Swaps On Digits",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Prefix Removal to Make Array Strictly Increasing",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Processing Time",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Recolors to Get K Consecutive Black Blocks",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Rectangles to Cover Points",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Relative Loss After Buying Chocolates",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Removals to Achieve Target XOR",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Removals to Balance Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Remove to Make Valid Parentheses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Replacements to Sort the Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Reverse Operations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Right Shifts to Sort the Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Rounds to Complete All Tasks",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Runes to Add to Cast Spell",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Score After Removals on a Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Score by Changing Two Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Score of a Path Between Two Cities",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Score Triangulation of Polygon",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Seconds to Equalize a Circular Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Sensors to Cover Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Sideway Jumps",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Size Subarray in Infinite Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Size Subarray Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Skips to Arrive at Meeting On Time",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Space Wasted From Packaging",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Speed to Arrive on Time",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Split Into Subarrays With GCD Greater Than One",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Stability Factor of Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Steps to Convert String with Operations",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum String Length After Balanced Removals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum String Length After Removing Substrings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Minimum Subarray Length With Distinct Sum At Least K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Subarrays in a Valid Split",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Subsequence in Non-Increasing Order",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Substring Partition of Equal Character Frequency",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Sum After Divisible Sum Deletions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Sum of Four Digit Number After Splitting Digits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Sum of Mountain Triplets I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Sum of Mountain Triplets II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Sum of Squared Difference",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Sum of Values by Dividing Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Swaps to Arrange a Binary Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Swaps to Avoid Forbidden Values",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Swaps to Group All 1's Together",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Swaps to Group All 1's Together II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Minimum Swaps To Make Sequences Increasing",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Swaps to Make Strings Equal",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Swaps to Move Zeros to End",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Swaps to Sort by Digit Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Minimum Threshold for Inversion Pairs Count",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Threshold Path With Limited Heavy Edges",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Time Difference",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time for K Connected Components",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time For K Virus Variants to Spread",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Geometry"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time Takes to Reach Destination Without Drowning",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time to Activate String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time to Break Locks I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Time to Break Locks II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Time to Build Blocks",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time to Collect All Apples in a Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Time to Complete All Deliveries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Time to Complete All Tasks",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time to Complete Trips",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Time to Eat All Grains",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time to Finish the Race",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Time to Kill All Monsters",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Time to Make Array Sum At Most x",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Time to Reach Destination in Directed Graph",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Time to Reach Target With Limited Power",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Time to Remove All Cars Containing Illegal Goods",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Time to Repair Cars",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum Time to Revert Word to Initial State I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time to Revert Word to Initial State II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time to Transport All Individuals",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Time to Type Word Using Special Typewriter",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time to Visit a Cell In a Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time to Visit All Houses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Time to Visit Disappearing Nodes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Time Visiting All Points",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Total Cost to Make Arrays Unequal",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Total Cost to Process All Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Total Distance Traveled",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Total Operations",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Total Space Wasted With K Resizing Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Unique Word Abbreviation",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Unlocked Indices to Sort Nums",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Minimum Value to Get Positive Step by Step Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum Weighted Subgraph With the Required Paths",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Minimum Weighted Subgraph With the Required Paths II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Minimum White Tiles After Covering With Carpets",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Window Subsequence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum Window Substring",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Minimum XOR Path in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Minimum XOR Sum of Two Arrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Mirror Distance of an Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Mirror Frequency Distance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Mirror Reflection",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Missing Element in Sorted Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Missing Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Missing Number In Arithmetic Progression",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Missing Ranges",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Modify Columns",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Modify Graph Edge Weights",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Modify the Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Monotone Increasing Digits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Monotonic Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Monthly Transactions I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Monthly Transactions II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Most Beautiful Item for Each Query",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Most Common Course Pairs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Most Common Word",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Most Expensive Item That Can Not Be Bought",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Most Frequent Even Element",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Most Frequent IDs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Most Frequent Number Following Key In an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Most Frequent Prime",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Most Frequent Subtree Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Most Popular Video Creator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Most Profit Assigning Work",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Most Profitable Path in a Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Most Stones Removed with Same Row or Column",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Most Visited Sector in a Circular Track",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Move Pieces to Obtain a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Move Sub-Tree of N-Ary Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Move Zeroes",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Movement of Robots",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Movie Rating",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Moving Average from Data Stream",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Queue"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Moving Stones Until Consecutive",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Moving Stones Until Consecutive II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Multi Source Flood Fill",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Multiply Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Multiply Two Polynomials",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "My Calendar I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "My Calendar II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "My Calendar III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "N-ary Tree Level Order Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "N-ary Tree Postorder Traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "N-ary Tree Preorder Traversal",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "N-Queens",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "N-Queens-II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "N-Repeated Element in Size 2N Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "N-th Tribonacci Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Naming a Company",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Nearest Exit from Entrance in Maze",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Neighboring Bitwise XOR",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Neither Minimum nor Maximum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Nested Array Generator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Nested List Weight Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Nested List Weight Sum II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Network Delay Time",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Network Recovery Pathways",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "New 21 Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "New Users Daily Count",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Next Closest Time",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Next Day",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Next Greater Element I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Next Greater Element II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Next Greater Element III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Next Greater Element IV",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Next Greater Node In Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Next Greater Numerically Balanced Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Next Palindrome Using Same Digits",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Next Permutation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Next Special Palindrome Number",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Nim Game",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Node With Highest Edge Score",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Non-decreasing Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Non-negative Integers without Consecutive Ones",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Non-overlapping Intervals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Not Boring Movies",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "NPV Queries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Nth Digit",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Nth Highest Salary",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Nth Magical Number",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Number Complement",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of 1 Bits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Accounts That Did Not Stream",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Adjacent Elements With the Same Color",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Alternating XOR Partitions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Arithmetic Triplets",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Atoms",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Number of Balanced Integers in a Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Beautiful Integers in the Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Beautiful Pairs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Beautiful Partitions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Bit Changes to Make Two Integers Equal",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Black Blocks",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Boomerangs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Burgers with No Waste of Ingredients",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Calls Between Two Persons",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Centered Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Changing Keys",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Closed Islands",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Comments per Post",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Common Factors",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Connected Components in an Undirected Graph",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number Of Corner Rectangles",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Days Between Two Dates",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Days in a Month",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Dice Rolls With Target Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Different Integers in a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Different Subsequences GCDs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Digit One",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Distinct Averages",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Number of Distinct Binary Strings After Applying Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Distinct Islands",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Distinct Islands II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Distinct Roll Sequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Distinct Substrings in a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Divisible Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Divisible Triplet Sums",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Effective Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Elapsed Seconds Between Two Times",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Employees Who Met the Target",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Enclaves",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Equal Count Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Number of Equal Numbers Blocks",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Number of Equivalent Domino Pairs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Even and Odd Bits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Excellent Pairs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Flowers in Full Bloom",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Number of Good Binary Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Good Leaf Nodes Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Number of Good Pairs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Good Paths",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Number of Good Ways to Split a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Great Partitions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Increasing Paths in a Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Integers With Popcount-Depth Equal to K I",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Integers With Popcount-Depth Equal to K II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Islands",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Islands II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Laser Beams in a Bank",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Lines To Write String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Longest Increasing Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Matching Subsequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Music Playlists",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Nodes in the Sub-Tree With the Same Label",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Number of Nodes With Value One",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Operations to Make Network Connected",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Orders in the Backlog",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Pairs After Increment",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Pairs of Interchangeable Rectangles",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Pairs of Strings With Concatenation Equal to Target",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Pairs Satisfying Inequality",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Number of Paths with Max Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of People Aware of a Secret",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of People That Can Be Seen in a Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Number of Perfect Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Number of Possible Sets of Closing Branches",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Number of Prefix Connected Groups",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Recent Calls",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Queue"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Number Of Rectangles That Can Form The Largest Square",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Restricted Paths From First to Last Node",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Number of Same-End Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Segments in a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Self-Divisible Permutations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Senior Citizens",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Sets of K Non-Overlapping Line Segments",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Number of Ships in a Rectangle",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Number of Single Divisor Triplets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Smooth Descent Periods of a Stock",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Spaces Cleaning Robot Cleaned",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Squareful Arrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Stable Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Steps to Reduce a Number in Binary Representation to One",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Steps to Reduce a Number to Zero",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Strings That Appear as Substrings in Word",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Strings Which Can Be Rearranged to Contain Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Student Replacements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Students Doing Homework at a Given Time",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Students Unable to Eat Lunch",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Sub-arrays of Size K and Average Greater than or Equal to Threshold",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Sub-arrays With Odd Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Subarrays Having Even Product",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Subarrays That Match a Pattern I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Subarrays That Match a Pattern II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Subarrays With AND Value of K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Subarrays with Bounded Maximum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Subarrays With GCD Equal to K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Subarrays With LCM Equal to K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Submatrices That Sum to Target",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Subsequences That Satisfy the Given Sum Condition",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Number of Subsequences with Odd Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Substrings Containing All Three Characters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Number of Substrings With Fixed Ratio",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Substrings With Only 1s",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Times a Driver Was a Passenger",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Transactions per Visit",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Trusted Contacts of a Customer",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Unequal Triplets in Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Unique Categories",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Unique Flavors After Sharing K Candies",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Number of Unique Good Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Unique Subjects Taught by Each Teacher",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Unique XOR Triplets I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Unique XOR Triplets II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Valid Clock Times",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Valid Move Combinations On Chessboard",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Valid Subarrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Number of Valid Words for Each Puzzle",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Valid Words in a Sentence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Visible People in a Queue",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Number of Ways of Cutting a Pizza",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Arrive at Destination",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Number of Ways to Assign Edge Weights I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Number of Ways to Assign Edge Weights II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Number of Ways to Build House of Cards",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Build Sturdy Brick Wall",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Buy Pens and Pencils",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Ways to Divide a Long Corridor",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Ways to Earn Points",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Form a Target String Given a Dictionary",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Paint N × 3 Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Paint Sheets",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Number of Ways to Reach a Position After Exactly k Steps",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Ways to Reach Destination in the Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Rearrange Sticks With K Sticks Visible",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number Of Ways To Reconstruct A Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Number of Ways to Reorder Array to Get Same BST",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Select Buildings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Separate Numbers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Split a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Ways to Split Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Ways to Stay in the Same Place After Some Steps",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways to Wear Different Hats to Each Other",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of Ways Where Square of Number Is Equal to Product of Two Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Wonderful Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of Zero-Filled Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Number of ZigZag Arrays I",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Number of ZigZag Arrays II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Number of ZigZag Arrays III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Numbers At Most N Given Digit Set",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Numbers With Repeated Digits",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Numbers With Same Consecutive Differences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Occurrences After Bigram",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Odd and Even Transactions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Odd Even Jump",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Odd Even Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Odd String Difference",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Once Twice",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "One Edit Distance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Ones and Zeroes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Online Election",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Online Majority Element In Subarray",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Online Stock Span",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Open the Lock",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Operations on Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Optimal Account Balancing",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Optimal Division",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Optimal Partition of String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Optimize Water Distribution in a Village",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Order Two Columns Independently",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Orderly Queue",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Orders With Maximum Quantity Above Average",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Out of Boundary Paths",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Output Contest Matches",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pacific Atlantic Water Flow",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Page Recommendations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Page Recommendations II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Paint Fence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Paint House",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Paint House II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Paint House III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Paint House IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Painting a Grid With Three Different Colors",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Painting the Walls",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Pairs of Songs With Total Durations Divisible by 60",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Palindrome Linked List",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Palindrome Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Palindrome Pairs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Palindrome Partitioning",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Palindrome Partitioning II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Palindrome Partitioning III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Palindrome Partitioning IV",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Palindrome Permutation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Palindrome Permutation II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Palindrome Rearrangement Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Palindrome Removal",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Palindromic Path Queries in a Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Palindromic Subarray Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Palindromic Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pancake Sorting",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Parallel Courses",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Parallel Courses II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Parallel Courses III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Parallel Execution of Promises for Individual Results Retrieval",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Parse Lisp Expression",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Parsing A Boolean Expression",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partial Function with Placeholders",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition Array According to Given Pivot",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Partition Array for Maximum Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Partition Array for Maximum XOR and AND",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition Array into Disjoint Intervals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition Array Into K-Distinct Groups",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition Array Into Three Parts With Equal Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition Array Into Two Arrays to Minimize Sum Difference",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition Array into Two Equal Product Subsets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition Array Such That Maximum Difference Is K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition Array to Minimize XOR",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Partition Equal Subset Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Partition Labels",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Partition String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition String Into Minimum Beautiful Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Partition String Into Substrings With Values at Most K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partition to K Equal Sum Subsets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Partitioning Into Minimum Number Of Deci-Binary Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pascal's Triangle",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pascal's Triangle II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pass the Pillow",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Password Strength",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Patching Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Path Crossing",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Path Existence Queries in a Graph I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Path Existence Queries in a Graph II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Path In Zigzag Labelled Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Path Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Path Sum II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Path Sum III",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Path Sum IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Path with Maximum Gold",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Path With Maximum Minimum Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Path with Maximum Probability",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Path With Minimum Effort",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Paths in Matrix Whose Sum Is Divisible by K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Paths in Maze That Lead to Same Room",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Patients With a Condition",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Peak Index in a Mountain Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Peaks in Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Peeking Iterator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "People Whose List of Favorite Companies Is Not a Subset of Another List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Percentage of Letter in String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Percentage of Users Attended a Contest",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Perfect Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Perfect Rectangle",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Perfect Squares",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Perform String Shifts",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Permutation Difference between Two Strings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Permutation in String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Permutation Sequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Permutations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Permutations II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Permutations III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Permutations IV",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Phone Number Prefix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pizza Toppings Cost Analysis",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pizza With 3n Slices",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Plates Between Candles",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Play with Chips",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Plus One",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Plus One Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Points That Intersect With Cars",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Poor Pigs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Popularity Percentage",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Populating Next Right Pointers in Each Node",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Populating Next Right Pointers in Each Node II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Positions of Large Groups",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Possible Bipartition",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pour Water",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pour Water Between Buckets to Make Water Levels Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Pow(x, n)",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Power Grid Maintenance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Power of Four",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Power of Heroes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Power of Three",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Power of Two",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Power Update After K-th Largest Insertion I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Power Update After K-th Largest Insertion II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Powerful Integers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Predict the Winner",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Prefix and Suffix Search",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Preimage Size of Factorial Zeroes Function",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Premier League Table Ranking",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Premier League Table Ranking II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Premier League Table Ranking III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Previous Permutation With One Swap",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Primary Department for Each Employee",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Prime Arrangements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Prime In Diagonal",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Prime Number of Set Bits in Binary Representation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Prime Pairs With Target Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Prime Palindrome",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Prime Subtraction Operation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Print Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Print FooBar Alternately",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Concurrency"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Print Immutable Linked List in Reverse",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Print in Order",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Concurrency"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Print Words Vertically",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Print Zero Even Odd",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Concurrency"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Prison Cells After N Days",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Probability of a Two Boxes Having The Same Number of Distinct Balls",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Process Restricted Friend Requests",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Process String with Special Operations I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Process String with Special Operations II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Process Tasks Using Servers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Product of Array Except Self",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Product of the Last K Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Product of Two Run-Length Encoded Arrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Product Price at a Given Date",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Product Sales Analysis I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Product Sales Analysis II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Product Sales Analysis III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Product Sales Analysis IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Product Sales Analysis V",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Product's Price for Each Store",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Product's Worth Over Invoices",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Products With Three or More Orders in Two Consecutive Years",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Profitable Schemes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Project Employees I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Project Employees II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Project Employees III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Projection Area of 3D Shapes",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Promise Pool",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Promise Time Limit",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Properties Graph",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Pseudo-Palindromic Paths in a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Push Dominoes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Put Boxes Into the Warehouse I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Put Boxes Into the Warehouse II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Put Marbles in Bags",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pyramid Transition Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Pythagorean Distance Nodes in a Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Queens That Can Attack the King",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Queries on a Permutation With Key",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Queries on Number of Points Inside a Circle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Queries Quality and Percentage",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Query Batching",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Query Kth Smallest Trimmed Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Queue Reconstruction by Height",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Rabbits in Forest",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Race Car",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Random Flip Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Random Pick Index",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Random Pick with Blacklist",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Random Pick with Weight",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Random Point in Non-overlapping Rectangles",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Range Addition",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Range Addition II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Range Frequency Queries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Range Module",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Range Product Queries of Powers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Range Sum of BST",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Range Sum of Sorted Subarray Sums",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Range Sum Query - Immutable",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Range Sum Query - Mutable",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Range Sum Query 2D - Immutable",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Range Sum Query 2D - Mutable",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Range XOR Queries with Subarray Reversals",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Rank Scores",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rank Teams by Votes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Rank Transform of a Matrix",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rank Transform of an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Ransom Note",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reach a Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reach End of Array With Max Score",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reachable Nodes In Subdivided Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reachable Nodes With Restrictions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reaching Points",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Read N Characters Given Read4",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Read N Characters Given Read4 II - Call multiple times",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rearrange Array Elements by Sign",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Rearrange Array to Maximize Prefix Score",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rearrange Characters to Make Target String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rearrange K Substrings to Form Target String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rearrange Products Table",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rearrange Spaces Between Words",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rearrange String k Distance Apart",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Rearrange Words in a Sentence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Rearranging Fruits",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reconstruct a 2-Row Binary Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reconstruct Itinerary",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Reconstruct Original Digits from English",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Recover a Tree From Preorder Traversal",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Recover Binary Search Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Recover the Original Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rectangle Area",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rectangle Area II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Rectangle Overlap",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rectangles Area",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Recyclable and Low Fat Products",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Redistribute Characters to Make All Strings Equal",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reduce Array Size to The Half",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reducing Dishes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reduction Operations to Make the Array Elements Equal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Redundant Connection",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Redundant Connection II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Reformat Date",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reformat Department Table",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reformat Phone Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reformat The String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Regions Cut By Slashes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Regular Expression Matching",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Relative Ranks",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Relative Sort Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Relocate Marbles",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove 9",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Adjacent Almost-Equal Characters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove All Adjacent Duplicates In String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Remove All Adjacent Duplicates in String II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Remove All Occurrences of a Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove All Ones With Row and Column Flips",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove All Ones With Row and Column Flips II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Remove Boxes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Remove Colored Pieces if Both Neighbors are the Same Color",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Comments",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Covered Intervals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Digit From Number to Maximize Result",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Duplicate Letters",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Duplicates From an Unsorted Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Remove Duplicates from Sorted Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Duplicates from Sorted Array II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Duplicates from Sorted List",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Remove Duplicates from Sorted List II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Remove Element",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Interval",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Invalid Parentheses",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove K Digits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove K-Balanced Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Remove Letter To Equalize Frequency",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Linked List Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Remove Max Number of Edges to Keep Graph Fully Traversable",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Remove Methods From Project",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Remove Nodes From Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Remove Nth Node From End of List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Remove One Element to Make the Array Strictly Increasing",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Outermost Parentheses",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Remove Palindromic Subsequences",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Stones to Minimize the Total",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Remove Sub-Folders from the Filesystem",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Trailing Zeros From a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Vowels from a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Remove Zero Sum Consecutive Nodes from Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Remove Zeros in Decimal Representation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Removing Minimum and Maximum From Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Removing Minimum Number of Magic Beans",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Removing Stars From a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rename Columns",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reorder List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Reorder Log Files",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Reorder Routes to Make All Paths Lead to the City Zero",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reordered Power of 2",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reorganize String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Repeat String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Repeated DNA Sequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Repeated String Match",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Repeated Substring Pattern",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Replace All ?'s to Avoid Consecutive Repeating Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Replace All Digits with Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Replace Elements in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Replace Elements with Greatest Element on Right Side",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Replace Employee ID With The Unique Identifier",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Replace Non-Coprime Numbers in Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Replace Question Marks in String to Minimize Its Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Replace the Substring for Balanced String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Replace Words",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Report Contiguous Dates",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Report Spam Message",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reported Posts",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reported Posts II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reschedule Meetings for Maximum Free Time I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Reschedule Meetings for Maximum Free Time II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reshape Data: Concatenate",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reshape Data: Melt",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reshape Data: Pivot",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reshape the Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Restaurant Growth",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Restore Finishing Order",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Restore IP Addresses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Restore The Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Restore the Array From Adjacent Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Resulting String After Adjacent Removals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Return Length of Arguments Passed",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reveal Cards In Increasing Order",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Bits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Degree of a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse K Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Letters Then Special Characters in a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Linked List",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Reverse Linked List II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Reverse Nodes in Even Length Groups",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Reverse Nodes in k-Group",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Reverse Odd Levels of Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Only Letters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Pairs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Reverse Prefix of Word",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Reverse String II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse String Prefix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Subarray To Maximize Array Value",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Substrings Between Each Pair of Parentheses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Reverse Vowels of a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Reverse Words in a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Words in a String II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Words in a String III",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reverse Words With Same Vowel Count",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Reward Top K Students",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Richest Customer Wealth",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Right Triangles",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rings and Rods",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rising Temperature",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "RLE Iterator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Robot Bounded In Circle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Robot Collisions",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Robot Return to Origin",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Robot Room Cleaner",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rolling Average Steps",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Roman to Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Root Equals Sum of Children",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Rotate Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rotate Function",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rotate Image",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rotate List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Rotate Non Negative Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rotate String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rotated Digits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Rotating the Box",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Rotting Oranges",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Row With Maximum Ones",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Running Sum of 1d Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Running Total for Different Genders",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Russian Doll Envelopes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Sales Analysis I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sales Analysis II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sales Analysis III",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sales by Day of the Week",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sales Person",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Same Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Satisfiability of Equality Equations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Score After Flipping Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Score of a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Score of Parentheses",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Score Validator",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Scramble String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Search a 2D Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Search a 2D Matrix II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Search in a Binary Search Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Search in a Sorted Array of Unknown Size",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Search in Rotated Sorted Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Search in Rotated Sorted Array II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Search Insert Position",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Search Suggestions System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Seasonal Sales Analysis",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Seat Reservation Manager",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Second Day Verification",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Second Degree Follower",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Second Highest Salary",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Second Highest Salary II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Second Largest Digit in a String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Second Minimum Node In a Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Second Minimum Time to Reach Destination",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Select Cells in Grid With Maximum Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Select Data",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "PD"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Select K Disjoint Special Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Self Crossing",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Self Dividing Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sell Diminishing-Valued Colored Balls",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Sellers With No Sales",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Selling Pieces of Wood",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Semi-Ordered Permutation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sender With Largest Word Count",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sentence Screen Fitting",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Sentence Similarity",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sentence Similarity II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sentence Similarity III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Separate Black and White Balls",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Separate Squares I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Geometry"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Separate Squares II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Geometry"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Separate the Digits in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sequence Reconstruction",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sequential Digits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sequential Grid Path Cover",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sequentially Ordinal Rank Tracker",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Serialize and Deserialize Binary Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Serialize and Deserialize BST",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Serialize and Deserialize N-ary Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Server Utilization Time",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Set Intersection Size At Least Two",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Set Matrix Zeroes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Set Mismatch",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shift 2D Grid",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shift Distance Between Two Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shifting Letters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shifting Letters II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shopping Offers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Short Encoding of Words",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest and Lexicographically Smallest Beautiful String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Shortest Bridge",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Common Supersequence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Shortest Completing Word",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Cycle in a Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Shortest Distance After Road Addition Queries I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Shortest Distance After Road Addition Queries II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Shortest Distance from All Buildings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Distance in a Line",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Distance in a Plane",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Distance to a Character",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Distance to Target Color",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Shortest Distance to Target String in a Circular Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Impossible Sequence of Rolls",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Constructive Algorithms"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Matching Substring",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Palindrome",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Path in a Grid with Obstacles Elimination",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Path in a Hidden Grid",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Shortest Path in a Weighted Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Shortest Path in Binary Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Path to Get All Keys",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Path to Get Food",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Path Visiting All Nodes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Shortest Path with Alternating Colors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Path With At Most K Consecutive Identical Characters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Shortest String That Contains Three Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Subarray to be Removed to Make Array Sorted",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Subarray With OR at Least K I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Shortest Subarray With OR at Least K II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Shortest Subarray with Sum at Least K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Shortest Uncommon Substring in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Unsorted Continuous Subarray",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Way to Form String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Word Distance",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Word Distance II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shortest Word Distance III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shuffle an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shuffle String",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Shuffle the Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sign of the Product of an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Similar RGB Color",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Similar String Groups",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Simple Bank System",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Simplified Fractions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Simplify Path",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Single Element in a Sorted Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Single Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Single Number II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Single Number III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Single-Row Keyboard",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Single-Threaded CPU",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Sleep",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sliding Puzzle",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sliding Subarray Beauty",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Sliding Window Maximum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Queue"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Sliding Window Median",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Slowest Key",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Absent Positive Greater Than Average",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest All-Ones Multiple",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Common Region",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Smallest Divisible Digit Product I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Divisible Digit Product II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Even Multiple",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Good Base",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Greater Multiple Made of Two Digits",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Index With Digit Sum Equal to Index",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Index With Equal Value",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Integer Divisible by K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest K-Length Subsequence With Occurrences of a Letter",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Missing Genetic Value in Each Subtree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Smallest Missing Integer Greater Than Sequential Prefix Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Missing Multiple of K",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Missing Non-negative Integer After Operations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Number in Infinite Set",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Number With All Set Bits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Number With Given Digit Product",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Pair With Different Frequencies",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Palindromic Rearrangement I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Palindromic Rearrangement II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Smallest Range I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Range II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Rectangle Enclosing Black Pixels",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Smallest Rotation with Highest Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Stable Index I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Stable Index II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest String Starting From Leaf",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Smallest String With A Given Numeric Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest String With Swaps",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Subarray to Sort in Every Sliding Window",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Smallest Subarrays With Maximum Bitwise OR",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Subsequence of Distinct Characters",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Substring With Identical Characters I",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Smallest Substring With Identical Characters II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Smallest Subtree with all the Deepest Nodes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Smallest Sufficient Team",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Smallest Unique Subarray",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Smallest Value After Replacing With Sum of Prime Factors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Smallest Value of the Rearranged Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Snail traversal",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Snake in Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Snakes and Ladders",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Snapshot Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Solve the Equation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Solving Questions With Brainpower",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Sort an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Array By Absolute Value",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Array by Increasing Frequency",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Array by Moving Items to Empty Space",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort Array By Parity",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort Array By Parity II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort Array Using Prefix Reversals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort By",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort Characters By Frequency",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Colors",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Even and Odd Indices Independently",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Features by Popularity",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Integers by Binary Reflection",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort Integers by The Number of 1 Bits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Integers by The Power Value",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Sort Items by Groups Respecting Dependencies",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort Linked List Already Sorted Using Absolute Values",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Sort List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Matrix by Diagonals",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort the Jumbled Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort the Matrix Diagonally",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort the Olympic Table",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort the People",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort the Students by Their Kth Score",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Threats by Severity and Exploitability",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sort Transformed Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Sort Vowels by Frequency",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sort Vowels in a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sorted GCD Pair Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sorting the Sentence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sorting Three Groups",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Soup Servings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Sparse Matrix Multiplication",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Special Array I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Special Array II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Special Array With X Elements Greater Than or Equal X",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Special Binary String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Special Permutations",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Special Positions in a Binary Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Spiral Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Spiral Matrix II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Spiral Matrix III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Spiral Matrix IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split a Circular Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Split a String in Balanced Strings",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split a String Into the Max Number of Unique Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split and Merge Array Transformation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split Array by Prime Indices",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split Array into Consecutive Subsequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split Array into Fibonacci Sequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split Array Into Maximum Number of Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split Array Largest Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Split Array with Equal Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Split Array With Minimum Difference",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Split Array With Same Average",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Split BST",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Split Concatenated Strings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split Linked List in Parts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Split Message Based on Limit",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split Strings by Separator",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split the Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split the Array to Make Coprime Products",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split Two Strings to Make Palindrome",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Split With Minimum Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Splitting a String Into Descending Consecutive Values",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sqrt(x)",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Squares of a Sorted Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Squirrel Simulation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Stable Subarrays With Equal Boundary and Interior Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Stamping the Grid",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Stamping The Sequence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Statistics from a Large Sample",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Status of Flight Tickets",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Step-By-Step Directions From a Binary Tree Node to Another",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Stepping Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Steps to Make Array Non-decreasing",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Stickers to Spell Word",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Stock Price Fluctuation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Stone Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Stone Game II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Stone Game III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Stone Game IV",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Stone Game IX",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Stone Game V",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Stone Game VI",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Stone Game VII",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Stone Game VIII",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Stone Removal Game",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Strange Printer",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Strange Printer II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Stream of Characters",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Strictly Palindromic Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "String Compression",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "String Compression II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "String Compression III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "String Matching in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "String to Integer (atoi)",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "String Transformation",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "String Transforms Into Another String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "String Without AAA or BBB",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Strings Differ by One Character",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Strobogrammatic Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Strobogrammatic Number II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Strobogrammatic Number III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Strong Friendship",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Strong Password Checker",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Strong Password Checker II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Student Attendance Record I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Student Attendance Record II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Students and Examinations",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Students Report By Geography",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Students With Invalid Departments",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subarray Product Less Than K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subarray Sum Equals K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subarray Sums Divisible by K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subarray With Elements Greater Than Varying Threshold",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Subarrays Distinct Element Sum of Squares I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Subarrays Distinct Element Sum of Squares II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Subarrays with K Different Integers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Subarrays with XOR at Least K",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subdomain Visit Count",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subrectangle Queries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subsequence After One Replacement",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Subsequence of Size K With the Largest Even Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subsequence Sum After Capping Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Subsequence With the Minimum Score",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Subsequences with a Unique Middle Mode I",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subsequences with a Unique Middle Mode II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subsets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subsets II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Substring Matching Pattern",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Substring with Concatenation of All Words",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Substring With Largest Variance",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Substring XOR Queries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Substrings of Size Three with Distinct Characters",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Substrings That Begin and End With the Same Letter",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subtract the Product and Sum of Digits of an Integer",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Subtree Inversion Sum",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Subtree Inversion Sum II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Subtree of Another Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Subtree Removal Game with Fibonacci Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Successful Pairs of Spells and Potions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Sudoku Solver",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum in a Matrix",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sum Multiples",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Absolute Differences in a Sorted Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sum of All Odd Length Subarrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Sum of All Subset XOR Totals",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Beautiful Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Beauty in the Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Beauty of All Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Compatible Numbers in Range I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Consecutive Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Consecutive Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Digit Differences of All Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Digits in Base K",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Digits in the Minimum Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Digits of String After Convert",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Distances",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Distances in Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Elements With Frequency Divisible by K",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Even Numbers After Queries",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Floored Pairs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of GCD of Formed Pairs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Good Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Good Subsequences",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Sum of Imbalance Numbers of All Subarrays",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Sum of Increasing Product Blocks",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Integers with Maximum Digit Range",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of K Subarrays With Length at Least M",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Sum of K-Digit Numbers in a Range",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of k-Mirror Numbers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Largest Prime Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Left Leaves",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Matrix After Queries",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Mutated Array Closest to Target",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Nodes with Even-Valued Grandparent",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Number and Its Reverse",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Numbers With Units Digit K",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Perfect Square Ancestors",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Sum of Prefix Scores of Strings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Primes Between Number and Its Reverse",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Remoteness of All Cells",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Root To Leaf Binary Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Sum of Scores of Built Strings",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Sortable Integers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum Of Special Evenly-Spaced Elements In Array",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Square Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Squares of Special Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Subarray Minimums",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Subarray Ranges",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Sum of Subsequence Widths",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Total Strength of Wizards",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Sum of Two Integers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Unique Elements",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Values at Indices With K Set Bits",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Variable Length Subarrays",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Sum of Weighted Modes in Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Sum Root to Leaf Numbers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Summary Ranges",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Super Egg Drop",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Super Palindromes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Super Pow",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Super Ugly Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Super Washing Machines",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Surface Area of 3D Shapes",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Geometry"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Surrounded Regions",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Suspicious Bank Accounts",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Swap Adjacent in LR String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Swap For Longest Repeated Character Substring",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Swap Nodes in Pairs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Swap Salary",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Swapping Nodes in a Linked List",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Swim in Rising Water",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Symmetric Coordinates",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Symmetric Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Synonymous Sentences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Tag Validator",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Take Gifts From the Richest Pile",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Take K of Each Character From Left and Right",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Taking Maximum Energy From the Mystic Dungeon",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Tallest Billboard",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Target Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Task Scheduler",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Task Scheduler II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Tasks Count in the Weekend",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Team Dominance by Pass Success",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Team Scores in Football Tournament",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Teemo Attacking",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Tenth Line",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Shell Script"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Ternary Expression Parser",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Text Justification",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Airport With the Most Traffic",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Category of Each Member in the Store",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Change in Global Rankings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Dining Philosophers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Concurrency"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Earliest and Latest Rounds Where Players Compete",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "The Earliest Moment When Everyone Become Friends",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "The Employee That Worked on the Longest Task",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The First Day of the Maximum Recorded Degree in Each City",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The k Strongest Values in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The K Weakest Rows in a Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The k-th Lexicographical String of All Happy Strings of Length n",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Knight’s Tour",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The kth Factor of n",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Latest Login in 2020",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Latest Time to Catch a Bus",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "The Maze",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Maze II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Maze III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Most Frequently Ordered Products for Each Customer",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Most Recent Orders for Each Product",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Most Recent Three Orders",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Most Similar Path in a Graph",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "The Number of Beautiful Subsets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "The Number of Employees Which Report to Each Employee",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Number of Full Rounds You Have Played",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Number of Good Subsets",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "The Number of Passengers in Each Bus I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Number of Passengers in Each Bus II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Number of Rich Customers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Number of Seniors and Juniors to Join the Company",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Number of Seniors and Juniors to Join the Company II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Number of the Smallest Unoccupied Chair",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "The Number of Users That Are Eligible for Discount",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Number of Ways to Make the Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Number of Weak Characters in the Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "The Score of Students Solving Math Expression",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "The Skyline Problem",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "The Time When the Network Becomes Idle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Two Sneaky Numbers of Digitville",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Users That Are Eligible for Discount",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Winner University",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "The Wording Game",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Third Maximum Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Thousand Separator",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Three Consecutive Odds",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Three Divisors",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Three Equal Parts",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Threshold Majority Queries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Throne Inheritance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Throttle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Tiling a Rectangle with the Fewest Squares",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Time Based Key-Value Store",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Time Needed to Buy Tickets",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Time Needed to Inform All Employees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Time Needed to Rearrange a Binary String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Time Taken to Cross the Door",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Time Taken to Mark All Nodes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Time to Cross a Bridge",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "To Be Or Not To Be",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "To Lower Case",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Toeplitz Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Toggle Light Bulbs",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Top K Frequent Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Top K Frequent Words",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Top Percentile Fraud",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Top Three Wineries",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Top Travellers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Toss Strange Coins",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Total Appeal of A String",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Total Characters in String After Transformations I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Total Characters in String After Transformations II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Total Cost to Hire K Workers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Total Distance to Type a String Using One Finger",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Total Distance Traveled",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Total Hamming Distance",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Total Sales Amount by Year",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Total Score of Dungeon Runs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Total Sum of Interaction Cost in Tree Groups",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Total Traveled Distance",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Total Waviness of Numbers in Range I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Total Waviness of Numbers in Range II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Tournament Winners",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Traffic Light Controlled Intersection",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Concurrency"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Traffic Signal Color",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Transform Array by Parity",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Transform Array to All Equal Elements",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Transform to Chessboard",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Transformed Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Transpose File",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Shell Script"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Transpose Matrix",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Trapping Rain Water",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Trapping Rain Water II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Tree Diameter",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Tree Node",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Tree of Coprimes",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Depth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Triangle",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Triangle Judgement",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Trim a Binary Search Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Trim Trailing Vowels",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Trionic Array I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Trionic Array II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Triples with Bitwise AND Equal To Zero",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Trips and Users",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Truncate Sentence",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Tuple with Same Product",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Tweet Counts Per Frequency",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Twisted Mirror Path Count",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Two Best Non-Overlapping Events",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Two City Scheduling",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Two Furthest Houses With Different Colors",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Two Out of Three",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Two Sum",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Two Sum BSTs",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Two Sum II - Input array is sorted",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Two Sum III - Data structure design",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Two Sum IV - Input is a BST",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Two Sum Less Than K",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Two-Letter Card Game",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Type of Triangle II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Ugly Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Ugly Number II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Heap (Priority Queue)"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Ugly Number III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Uncommon Words from Two Sentences",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Uncrossed Lines",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Undefined to Null",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "JS"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique 3-Digit Even Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique Binary Search Trees",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Unique Binary Search Trees II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique Email Addresses",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique Email Groups",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique Length-3 Palindromic Subsequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique Middle Element",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique Morse Code Words",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique Number of Occurrences",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique Orders and Customers Per Month",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique Paths",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Unique Paths II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Unique Paths III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Unique Substrings in Wraparound String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Unique Substrings With Equal Digit Frequency",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unique Word Abbreviation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unit Conversion I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Unit Conversion II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Univalued Binary Tree",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Unpopular Books",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "User Activities within Time Bounds",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "User Activity for the Past 30 Days I",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "User Activity for the Past 30 Days II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "User Purchase Platform",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Users That Actively Request Confirmation Messages",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Users With Two Purchases Within Seven Days",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Using a Robot to Print the Lexicographically Smallest String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "UTF-8 Validation",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Anagram",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Arrangement of Pairs",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Valid Binary Strings With Cost Limit",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Boomerang",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Digit Number",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Elements in an Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Mountain Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Number",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Palindrome",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Palindrome II",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Palindrome III",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Valid Palindrome IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Valid Parentheses",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Valid Parenthesis String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Perfect Square",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Valid Permutations for DI Sequence",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Valid Phone Numbers",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Shell Script"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Square",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Subarrays With Exactly One Peak",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Valid Subarrays With Matching Sum Digits I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Valid Subarrays With Matching Sum Digits II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Valid Sudoku",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Tic-Tac-Toe State",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Triangle Number",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Valid Word",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Word Abbreviation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Valid Word Square",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Validate Binary Search Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Recursion"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Validate Binary Tree Nodes",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Graph"
    ],
    "template": "courseSchedule",
    "source": "online"
  },
  {
    "title": "Validate IP Address",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Validate Stack Sequences",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Verbal Arithmetic Puzzle",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Verify Preorder Sequence in Binary Search Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Verify Preorder Serialization of a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Stack"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Verifying an Alien Dictionary",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Vertical Order Traversal of a Binary Tree",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Tree"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Video Stitching",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Viewers Turned Streamers",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Visit Array Positions to Maximize Score",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Vowel Spellchecker",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Vowel-Consonant Score",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Vowels Game in a String",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Vowels of All Substrings",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Walking Robot Simulation",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Walking Robot Simulation II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Walls and Gates",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Warehouse Manager",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Water and Jug Problem",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Water Bottles",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Water Bottles II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Simulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Watering Plants",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Watering Plants II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Ways to Express an Integer as Sum of Powers",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Ways to Make a Fair Array",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Ways to Split Array Into Good Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Ways to Split Array Into Three Subarrays",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Two Pointers"
    ],
    "template": "slidingWindow",
    "source": "online"
  },
  {
    "title": "Weather Type in Each Country",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Web Crawler",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Design"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Web Crawler Multithreaded",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Concurrency"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Weighted Word Mapping",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Where Will the Ball Fall",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Widest Pair of Indices With Equal Range Sum",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Widest Vertical Area Between Two Points Containing No Points",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Wiggle Sort",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Wiggle Sort II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Wiggle Subsequence",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Wildcard Matching",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Winner of the Linked List Game",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Linked List"
    ],
    "template": "addTwoNumbersArray",
    "source": "online"
  },
  {
    "title": "Winning Candidate",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Abbreviation",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Break",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "Word Break II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Frequency",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Shell Script"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Ladder",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Ladder II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Pattern",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Pattern II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Search",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Search II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Squares",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Word Squares II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Sorting"
    ],
    "template": "intervals",
    "source": "online"
  },
  {
    "title": "Word Subsets",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Words Within Two Edits of Dictionary",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Hash Table"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "X of a Kind in a Deck of Cards",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "XOR After Range Multiplication Queries I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "XOR After Range Multiplication Queries II",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "XOR Operation in an Array",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Math"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "XOR Queries of a Subarray",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Bit Manipulation"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Year on Year Growth Rate",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "SQL"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Zero Array Transformation I",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Zero Array Transformation II",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Binary Search"
    ],
    "template": "binarySearch",
    "source": "online"
  },
  {
    "title": "Zero Array Transformation III",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Greedy"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Zero Array Transformation IV",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Dynamic Programming"
    ],
    "template": "dp",
    "source": "online"
  },
  {
    "title": "ZigZag Conversion",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "String"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Zigzag Grid Traversal With Skip",
    "difficulty": "Easy",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Array"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Zigzag Iterator",
    "difficulty": "Medium",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Queue"
    ],
    "template": "stack",
    "source": "online"
  },
  {
    "title": "Zigzag Level Sum of Binary Tree",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Breadth-First Search"
    ],
    "template": "twoSum",
    "source": "online"
  },
  {
    "title": "Zuma Game",
    "difficulty": "Hard",
    "companies": [
      "NA"
    ],
    "patterns": [
      "Backtracking"
    ],
    "template": "twoSum",
    "source": "online"
  }
];
